import type { Category } from "@/lib/types";

/**
 * EN Ingredient → Category Dictionary
 *
 * Contains ONLY singular base forms without quantities or containers.
 * Examples: "chicken", "corn", "salsa" (not "2 lbs chicken", "bag of corn", "jar of salsa")
 *
 * The algorithm handles:
 * - Pluralization (beans → bean)
 * - Quantity stripping (2 lbs → removed)
 * - Container removal (jar of → removed)
 *
 * Generated from test data.
 * Total entries: 3799
 */

export const enDictionary: Record<string, Category> = {
  "1% milk": "dairy", // exception: percentage is part of product name
  "2% milk": "dairy", // exception: percentage is part of product name
  "2% yogurt": "dairy", // exception: percentage is part of product name
  "a&w root beer": "other",
  "a1 sauce": "other",
  "a1 steak sauce": "other",
  "a2 milk": "dairy",
  abiu: "fruit",
  "abuelita chocolate": "other",
  aburaage: "other",
  acai: "fruit",
  "acai berry": "fruit",
  "acidophilus milk": "dairy",
  ackee: "fruit",
  "acorn squash": "produce",
  "act ii popcorn": "other",
  "active dry yeast": "other",
  "adobo seasoning": "other",
  "agar agar": "other",
  "agave nectar": "other",
  "age tofu": "other",
  "aged cheddar": "dairy",
  "aged goat cheese": "dairy",
  "aged gouda": "dairy",
  "aged mimolette": "dairy", // aged mimolette cheese
  "aged provolone": "dairy",
  "agua fresca": "other",
  "aha sparkling water": "other",
  "ahi tuna": "seafood",
  aioli: "other",
  airhead: "other",
  aji: "seafood",
  akee: "fruit",
  "al pastor": "meat",
  "alani nu": "other",
  albacore: "seafood",
  ale: "other",
  "alfredo sauce": "other",
  "alfalfa sprouts": "produce", // edible sprouted seeds
  "alkaline water": "other",
  "all beef hot dog": "meat",
  "all bran": "other",
  "all purpose flour": "other",
  alligator: "meat",
  allspice: "other",
  almond: "other",
  "almond butter": "other",
  "almond extract": "other",
  "almond flour": "other",
  "almond joy": "other",
  "almond milk": "dairy", // plant-based milk in dairy section
  "almond yogurt": "dairy",
  "aloe drink": "other",
  "aloe vera drink": "other",
  alouette: "dairy",
  altoid: "other",
  amaranth: "other",
  amberjack: "seafood",
  "ambrosia apple": "fruit",
  amchur: "other",
  "american cheese": "dairy",
  "anaheim pepper": "produce",
  anardana: "other",
  "ancho chili powder": "other",
  anchovy: "seafood",
  andouille: "meat",
  "andouille sausage": "meat",
  "angel food cake": "other",
  "angel hair pasta": "other",
  "animal cracker": "other",
  "anjou pear": "fruit",
  anko: "other",
  antipasto: "other",
  apple: "fruit",
  "apple butter": "other",
  "apple chip": "other",
  "apple cider vinaigrette": "other",
  "apple cider vinegar": "other",
  "apple fritter": "other",
  "apple juice": "other",
  "apple pear": "fruit",
  "apple pie": "other",
  "apple pie spice": "other",
  "apple strudel": "other",
  "apple tart": "other",
  "apple turnover": "other",
  applesauce: "other",
  "applesauce cup": "other",
  apricot: "fruit",
  "apricot preserf": "other",
  aprium: "fruit",
  aquafina: "other",
  arame: "other",
  "arborio rice": "other",
  "arctic char": "seafood", // Arctic char fish
  "arizona iced tea": "other",
  "arm roast": "meat",
  "armenian cucumber": "produce",
  "arnold palmer": "other",
  "aronia berry": "fruit",
  "arrabbiata sauce": "other",
  arrabiata: "other",
  "arrabiata sauce": "other",
  arrowroot: "other",
  artichoke: "produce",
  "artichoke dip": "other",
  "artichoke heart": "produce",
  "artificial sweetener": "other",
  arugula: "produce",
  asafoetida: "other",
  "ash gourd": "produce",
  asiago: "dairy",
  "asiago cheese": "dairy",
  "asian dressing": "other",
  "asian eggplant": "produce",
  "asian pear": "fruit",
  "asian sesame dressing": "other",
  asparagus: "produce",
  atemoya: "fruit",
  "au gratin potato": "other",
  "au jus": "other",
  "au jus mix": "other",
  "aunt jemima": "other",
  "australian finger lime": "fruit",
  "australian yogurt": "dairy",
  avocado: "produce",
  "avocado dressing": "other",
  "avocado oil": "other",
  ayran: "dairy",
  "azuki paste": "other",
  "baba ganoush": "other",
  babaco: "fruit",
  "baby artichoke": "produce",
  "baby arugula": "produce",
  "baby asparagus": "produce",
  "baby back rib": "meat",
  "baby beet": "produce",
  "baby bella mushroom": "produce",
  "baby bok choy": "produce",
  "baby broccoli": "produce",
  "baby carrot": "produce",
  "baby cereal": "other",
  "baby corn": "produce",
  "baby food": "other",
  "baby formula": "other",
  "baby greens": "produce", // mixed baby salad greens
  "baby kale": "produce",
  "baby kiwi": "fruit",
  "baby leek": "produce",
  "baby oatmeal": "other",
  "baby pineapple": "fruit",
  "baby portobello": "produce",
  "baby potato": "produce",
  "baby puff": "other",
  "baby pumpkin": "produce",
  "baby rice cereal": "other",
  "baby ruth": "other",
  "baby snack": "other",
  "baby spinach": "produce",
  "baby swiss": "dairy",
  "baby turnip": "produce",
  "baby yogurt": "other",
  babybel: "dairy",
  "back rib": "meat",
  bacon: "meat",
  "bacon bit": "other",
  "bacon crumble": "other",
  "bacon jerky": "other",
  "baechu kimchi": "other",
  bagel: "other",
  "bagel chip": "other",
  "bagged salad": "produce",
  baguette: "other",
  "baked bean": "other",
  "baked potato": "other",
  "baked ziti": "other",
  "baking chocolate": "other",
  "baking powder": "other",
  "baking soda": "other",
  baklava: "other",
  "balkan yogurt": "dairy",
  "balsamic dressing": "other",
  "balsamic glaze": "other",
  "balsamic vinaigrette": "other",
  "balsamic vinegar": "other",
  "bamboo shoot": "produce",
  banana: "fruit",
  "banana blossom": "produce",
  "banana bread": "other",
  "banana chip": "other",
  "banana cream pie": "other",
  "banana flower": "produce",
  "banana milk": "other",
  "banana pepper": "produce",
  "banana peppers": "other",
  "banana pudding": "other",
  "bang energy": "other",
  "banh trang": "other",
  "barbecue sauce": "other",
  barberry: "fruit",
  barley: "other",
  "barq's root beer": "other",
  barramundi: "seafood",
  "bartlett pear": "fruit",
  basil: "produce",
  "basil pesto": "other",
  "basmati rice": "other",
  bass: "seafood",
  batata: "produce",
  "bay leaf": "produce",
  bayberry: "fruit",
  "bbq chicken": "meat",
  "bbq chip": "other",
  "bbq rib": "other",
  "bbq sauce": "other",
  "bbq seasoning": "other",
  bean: "other",
  "bean dip": "other",
  "bean sprout": "produce",
  "bean thread noodle": "other",
  "bear claw": "other",
  bearberry: "fruit",
  "beech mushroom": "produce",
  beef: "meat",
  "beef bones": "meat",
  "beef brisket": "meat",
  "beef broth": "other",
  "beef burger": "meat",
  "beef cube steak": "meat",
  "beef fajita meat": "meat",
  "beef gravy": "other",
  "beef heart": "meat",
  "beef hot dog": "meat",
  "beef jerky": "other",
  "beef kabob": "meat",
  "beef kidney": "meat",
  "beef liver": "meat",
  "beef meatballs": "meat",
  "beef patty": "meat",
  "beef pot pie": "other",
  "beef ribs": "meat",
  "beef shank": "meat",
  "beef short ribs": "meat",
  "beef stew meat": "meat",
  "beef sticks": "other",
  "beef stir fry": "meat",
  "beef stock": "other",
  "beef tenderloin": "meat",
  "beef tips": "meat",
  "beef tomato": "produce",
  "beef tongue": "meat",
  "beefsteak tomato": "produce", // culinary usage
  "beefsteak tomatoes": "produce", // plural form
  beer: "other",
  "beer mustard": "other",
  beet: "produce",
  "beet chip": "other",
  beetroot: "produce",
  beignet: "other",
  "bel paese": "dairy",
  "belgian endive": "produce",
  "bell pepper": "produce",
  "bell peppers": "produce",
  "bella mushroom": "produce",
  "beni shoga": "other",
  bergamot: "fruit",
  "bergamot orange": "fruit",
  "best foods mayo": "other",
  "beurre noisette": "dairy",
  "beyond burger": "other",
  "bhut jolokia": "produce",
  "bibb lettuce": "produce",
  "bicolor corn": "produce",
  "big mac sauce": "other",
  "bigeye tuna": "seafood",
  berry: "fruit", // singular berry
  berries: "fruit", // plural/generic berries
  bilberry: "fruit",
  biltong: "meat",
  "bing cherry": "fruit",
  "bird chili": "produce",
  "bird seed": "other",
  "bird's eye chili": "produce",
  "birthday cake": "other",
  "biryani masala": "other",
  biscotti: "other",
  biscuit: "other",
  bison: "meat",
  "bison burger": "meat",
  "bison steak": "meat",
  bisquick: "other",
  bitter: "other",
  "bitter gourd": "produce",
  "bitter melon": "produce",
  "bitter orange": "fruit",
  "black angus": "meat", // Black Angus beef breed
  "black bass": "seafood",
  "black bean": "other",
  "black bean burger": "other",
  "black bean garlic sauce": "other",
  "black bean salsa": "other",
  "black bean sauce": "other",
  "black cardamom": "other",
  "black cod": "seafood",
  "black currant": "fruit",
  "black forest gummy bear": "other",
  "black forest ham": "meat",
  "black fungus": "produce",
  "black grape": "fruit",
  "black mulberry": "fruit",
  "black mustard seed": "other",
  "black olif": "other",
  "black pepper": "other",
  "black plantain": "produce",
  "black plum": "fruit",
  "black pudding": "meat",
  "black radish": "produce",
  "black rice": "other",
  "black salsify": "produce",
  "black tea": "other",
  "black trumpet mushroom": "produce",
  "black vinegar": "other", // chinkiang/chinese black vinegar
  "chinkiang black vinegar": "other",
  blackberry: "fruit",
  "blackberry pie": "other",
  blackcurrant: "fruit",
  "blackstrap molass": "other",
  "bleu cheese": "dairy",
  blondie: "other",
  blondy: "other",
  "blood orange": "fruit",
  "blood sausage": "meat",
  "bloody mary mix": "other",
  "blooming onion": "other",
  "blow pop": "other",
  "blue cheese": "dairy",
  "blue cheese dressing": "other",
  "blue diamond almond": "other",
  "blue potato": "produce",
  "blue pumpkin": "produce",
  blueberry: "fruit",
  "blueberry bagel": "other",
  "blueberry jam": "other",
  "blueberry muffin": "other",
  "blueberry muffin mix": "other",
  "blueberry pie": "other",
  "blueberry yogurt": "dairy",
  "bluefin tuna": "seafood",
  bluefish: "seafood",
  boar: "meat",
  "boba tea": "other",
  "boiling onion": "produce",
  "bok choy": "produce",
  bologna: "meat",
  "bolognese sauce": "other",
  "bolthouse farm": "other",
  "bone broth": "other",
  "bone-in chicken breast": "meat",
  "bone-in chicken thigh": "meat",
  "bone-in ham": "meat",
  "bone-in leg of lamb": "meat",
  "bone-in pork chop": "meat",
  "bone-in ribeye": "meat",
  "bone-in turkey breast": "meat",
  "boneless chicken breast": "meat",
  "boneless chicken thigh": "meat",
  "boneless ham": "meat",
  "boneless leg of lamb": "meat",
  "boneless pork chop": "meat",
  "boneless turkey breast": "meat",
  boniato: "produce",
  bonito: "seafood",
  "bonito flake": "other",
  "boom chicka pop": "other",
  boost: "other",
  "bosc pear": "fruit",
  "boston butt": "meat",
  "boston lettuce": "produce",
  "bottle gourd": "produce",
  "bottled coffee": "other",
  "bottled green tea": "other",
  "bottled latte": "other",
  "bottled mocha": "other",
  "bottled smoothie": "other",
  "bottled water": "other",
  "bottom round roast": "meat",
  "bottom sirloin": "meat",
  bouillon: "other",
  "bouillon cube": "other",
  bourbon: "other",
  boursin: "dairy",
  "bow tie pasta": "other",
  boysenberry: "fruit", // hybrid berry
  "braeburn apple": "fruit",
  "bragg liquid amino": "other",
  "bran flake": "other",
  "bran muffin": "other",
  brandy: "other",
  branzino: "seafood",
  bratwurst: "meat",
  braunschweiger: "meat",
  "brazil nut": "other",
  bread: "other",
  "bread and butter pickles": "other",
  "bread crumbs": "other",
  "bread flour": "other",
  "bread pudding": "other",
  breadcrumbs: "other",
  breadfruit: "fruit",
  "breakfast bar": "other",
  "breakfast bowl": "other",
  "breakfast burrito": "other",
  "breakfast sandwich": "other",
  "breakfast sausage": "other",
  bream: "seafood",
  breast: "meat", // generic meat cut
  "breath mint": "other",
  bresaola: "meat",
  brie: "dairy",
  "brie cheese": "dairy",
  brioche: "other",
  "brisk iced tea": "other",
  brisket: "meat",
  broccoli: "produce",
  "broccoli rabe": "produce",
  "broccoli salad": "other",
  "broccoli slaw": "produce",
  broccolini: "produce",
  "brown butter": "dairy",
  "brown egg": "dairy",
  "brown gravy": "other",
  "brown rice": "other",
  "brown sauce": "other",
  "brown sugar": "other",
  "browned butter": "dairy",
  brownie: "other",
  "brownie mix": "other",
  browny: "other",
  "brussels sprout": "produce",
  "bubble gum": "other",
  "bubble tea": "other",
  bubly: "other",
  buckwheat: "other",
  "buckwheat noodle": "other",
  "buddha's hand": "fruit",
  buffalo: "meat",
  "buffalo chicken": "meat",
  "buffalo mozzarella": "dairy",
  "buffalo sauce": "other",
  "buffalo wild wings sauce": "other",
  "buffalo wing": "other",
  bugle: "other",
  "bulgarian buttermilk": "dairy",
  "bulgarian feta": "dairy",
  "bulgarian yogurt": "dairy",
  "bulgogi marinade": "other",
  "bulgogi sauce": "other",
  bulgur: "other",
  "bulgur wheat": "other",
  bun: "other",
  "bunched spinach": "produce",
  "bundt cake": "other",
  "burdock root": "produce",
  burger: "meat",
  "burger patty": "meat",
  burrata: "dairy",
  "burrata cheese": "dairy",
  burrito: "other",
  "burrito tortilla": "other",
  butter: "dairy",
  "butter chicken sauce": "other",
  "butter lettuce": "produce",
  "butter popcorn": "other",
  "butter spread": "dairy",
  "buttercup squash": "produce",
  butterfinger: "other",
  buttermilk: "dairy",
  "buttermilk biscuit": "other",
  "buttermilk dressing": "other",
  "butternut squash": "produce",
  "butterscotch candy": "other",
  "butterscotch chips": "other",
  "butterscotch sauce": "other",
  "button mushroom": "produce",
  "c4 energy": "other",
  cabbage: "produce",
  "cabbage slaw mix": "produce",
  "cactus pad": "produce",
  "cactus pear": "fruit",
  "caesar dressing": "other",
  "caesar salad": "other",
  "caesar salad kit": "other",
  "cafe du monde": "other",
  cajeta: "other",
  "cajun seasoning": "other",
  "cajun turkey": "meat",
  cake: "other",
  "cake flour": "other",
  "cake mix": "other",
  calabaza: "produce",
  "calabaza squash": "produce",
  calamansi: "fruit",
  calamari: "seafood",
  calamondin: "fruit",
  "calcium supplement": "other",
  "california roll": "other",
  cambozola: "dairy",
  camembert: "dairy",
  "campari tomato": "produce",
  "canada dry": "other",
  "canadian bacon": "meat",
  "candied pecan": "other",
  candy: "other",
  "candy bar": "other",
  "candy cane": "other",
  "candy cane beet": "produce",
  "candy corn": "other",
  "candy melt": "other",
  "cane sugar": "other",
  canistel: "fruit",
  "canned albacore tuna": "other",
  "canned anchovy": "other",
  "canned apple": "other",
  "canned apple pie filling": "other",
  "canned artichoke heart": "other",
  "canned asparagus": "other",
  "canned baby clam": "other",
  "canned baked bean": "other",
  "canned bamboo shoot": "other",
  "canned bean": "other",
  "canned bean salad": "other",
  "canned beef broth": "other",
  "canned beef chili": "other",
  "canned beef stock": "other",
  "canned beet": "other",
  "canned biscuit": "other",
  "canned black bean": "other",
  "canned black eyed pea": "other",
  "canned black refried bean": "other",
  "canned blueberry pie filling": "other",
  "canned bread dough": "other",
  "canned broth": "other",
  "canned butter beans": "other",
  "canned button mushroom": "other",
  "canned candied yam": "other",
  "canned cannellini bean": "other",
  "canned carrot": "other",
  "canned cherry": "other",
  "canned cherry pie filling": "other",
  "canned cherry tomato": "other",
  "canned chicken": "other",
  "canned chicken breast": "other",
  "canned chicken broth": "other",
  "canned chicken noodle soup": "other",
  "canned chicken stock": "other",
  "canned chickpea": "other",
  "canned chili": "other",
  "canned chili with bean": "other",
  "canned chili without bean": "other",
  "canned chipotle peppers": "other",
  "canned chipotles in adobo": "other",
  "canned chopped clam": "other",
  "canned chopped green chily": "other",
  "canned chunk chicken": "other",
  "canned chunk light tuna": "other",
  "canned cinnamon roll": "other",
  "canned clam": "other",
  "canned clam chowder": "other",
  "canned coconut cream": "other",
  "canned coconut milk": "other",
  "canned coffee": "other",
  "canned collard green": "other",
  "canned condensed milk": "other",
  "canned corn": "other",
  "canned corned beef": "other",
  "canned crab": "other",
  "canned crabmeat": "other",
  "canned cranberry sauce": "other",
  "canned cream of celery": "other",
  "canned cream of chicken": "other",
  "canned cream of mushroom": "other",
  "canned cream style corn": "other",
  "canned crescent roll": "other",
  "canned crushed pineapple": "other",
  "canned crushed tomato": "other",
  "canned cut green bean": "other",
  "canned dark sweet cherry": "other",
  "canned diced green chily": "other",
  "canned diced tomato": "other",
  "canned evaporated milk": "other",
  "canned fire roasted tomato": "other",
  "canned french style green bean": "other",
  "canned frosting": "other",
  "canned fruit": "other",
  "canned fruit cocktail": "other",
  "canned garbanzo bean": "other",
  "canned grapefruit": "other",
  "canned great northern bean": "other",
  "canned green bean": "other",
  "canned green chily": "other",
  "canned green pea": "other",
  "canned ham": "other",
  "canned hearts of palm": "other",
  "canned hominy": "other",
  "canned hot dog": "other",
  "canned icing": "other",
  "canned jalapeno": "other",
  "canned jalapeño": "other",
  "canned jellied cranberry sauce": "other",
  "canned kale": "other",
  "canned kidney bean": "other",
  "canned lemon pie filling": "other",
  "canned lentil": "other",
  "canned lima bean": "other",
  "canned mackerel": "other",
  "canned mandarin orange": "other",
  "canned maraschino cherry": "other",
  "canned mexicorn": "other",
  "canned minestrone": "other",
  "canned mixed fruit": "other",
  "canned mixed green": "other",
  "canned mixed vegetable": "other",
  "canned mushroom": "other",
  "canned mussel": "other",
  "canned mustard green": "other",
  "canned navy bean": "other",
  "canned orange": "other",
  "canned oyster": "other",
  "canned pea": "other",
  "canned peach": "other",
  "canned peach half": "other",
  "canned peach pie filling": "other",
  "canned peach slice": "other",
  "canned pear": "other",
  "canned pear half": "other",
  "canned pear slice": "other",
  "canned peas and carrot": "other",
  "canned petite diced tomato": "other",
  "canned pickled beet": "other",
  "canned pineapple": "other",
  "canned pineapple chunk": "other",
  "canned pineapple ring": "other",
  "canned pineapple slice": "other",
  "canned pink salmon": "other",
  "canned pinto bean": "other",
  "canned pinto refried bean": "other",
  "canned pizza dough": "other",
  "canned plum tomato": "other",
  "canned pork and beans": "other",
  "canned pumpkin": "other",
  "canned pumpkin puree": "other",
  "canned red kidney bean": "other",
  "canned red salmon": "other",
  "canned refried bean": "other",
  "canned roast beef": "other",
  "canned rotel": "other",
  "canned salmon": "other",
  "canned san marzano tomato": "other",
  "canned sardine": "other",
  "canned sauerkraut": "other",
  "canned shiitake mushroom": "other",
  "canned shrimp": "other",
  "canned sliced beet": "other",
  "canned sliced carrot": "other",
  "canned sliced mushroom": "other",
  "canned smoked oyster": "other",
  "canned sockeye salmon": "other",
  "canned soup": "other",
  "canned spam": "other",
  "canned spinach": "other",
  "canned stewed tomato": "other",
  "canned stock": "other",
  "canned strawberry pie filling": "other",
  "canned succotash": "other",
  "canned sweet corn": "other",
  "canned sweet pea": "other",
  "canned sweet potato": "other",
  "canned sweetened condensed milk": "other",
  "canned tart cherry": "other",
  "canned three bean salad": "other",
  "canned tomato": "other",
  "canned tomato paste": "other",
  "canned tomato puree": "other",
  "canned tomato sauce": "other",
  "canned tomato soup": "other",
  "canned tomatoes with green chily": "other",
  "canned tuna": "other",
  "canned tuna in oil": "other",
  "canned tuna in water": "other",
  "canned turkey": "other",
  "canned turkey chili": "other",
  "canned turnip green": "other",
  "canned vegetable broth": "other",
  "canned vegetable soup": "other",
  "canned vegetable stock": "other",
  "canned vegetarian chili": "other",
  "canned vegetarian refried bean": "other",
  "canned vienna sausage": "other",
  "canned water chestnuts": "other",
  "canned wax bean": "other",
  "canned whipped cream": "other",
  "canned white chicken chili": "other",
  "canned white hominy": "other",
  "canned white kidney bean": "other",
  "canned whole beet": "other",
  "canned whole cranberry sauce": "other",
  "canned whole kernel corn": "other",
  "canned whole mushroom": "other",
  "canned whole tomato": "other",
  "canned yam": "other",
  "canned yellow hominy": "other",
  cannoli: "other",
  "canola oil": "other",
  cantaloupe: "fruit",
  "cape cod chip": "other",
  "cape gooseberry": "fruit",
  caper: "other",
  capicola: "meat",
  capocollo: "meat",
  capon: "meat",
  cappuccino: "other",
  "capri sun": "other",
  "cara cara orange": "fruit",
  carambola: "fruit",
  "caramel corn": "other",
  "caramel popcorn": "other",
  "caramel rice cakes": "other",
  "caramel sauce": "other",
  "caraway seed": "other",
  "carbonara sauce": "other",
  cardamom: "other",
  "cardamom pod": "other",
  "carne asada": "meat",
  carnita: "meat",
  "carnival squash": "produce",
  "carolina bbq sauce": "other",
  "carolina reaper": "produce", // Carolina Reaper pepper variety
  "carolina reaper sauce": "other",
  carrot: "produce",
  "carrot cake": "other",
  "carrot cake mix": "other",
  "carrot chip": "other",
  "casaba melon": "fruit",
  "cascabel pepper": "produce",
  cashew: "other",
  "cashew butter": "other",
  "cashew milk": "dairy",
  "caspian sea yogurt": "dairy",
  cassava: "produce",
  "cassava chip": "other",
  "casu marzu": "dairy",
  "cat food": "other",
  "cat treat": "other",
  "catalina dressing": "other",
  catfish: "seafood",
  cauliflower: "produce",
  cavatelli: "other",
  cayenne: "other",
  "cayenne pepper": "other",
  "cayenne powder": "other",
  calf: "meat", // generic young cow meat (veal)
  celeriac: "produce",
  celery: "produce",
  "celery heart": "produce",
  "celery rib": "produce", // celery stalk/rib
  "celery root": "produce",
  "celery salt": "other",
  "celery seed": "other",
  "celery stalk": "produce",
  "cellophane noodle": "other",
  celsius: "other",
  "center cut bacon": "meat",
  "center cut pork chop": "meat",
  cereal: "other",
  "cereal bar": "other",
  "chaat masala": "other",
  chai: "other",
  "chai latte": "other",
  "chai tea": "other",
  challah: "other",
  "chamomile tea": "other",
  champagne: "other",
  "champagne grape": "fruit",
  "champagne vinegar": "other",
  "chana masala": "other",
  chanterelle: "produce",
  "chanterelle mushroom": "produce",
  chapati: "other",
  "char siu sauce": "other",
  charcuterie: "meat",
  chard: "produce",
  chayote: "produce",
  cheddar: "dairy",
  "cheddar cheese": "dairy",
  "cheddar chip": "other",
  cheerio: "other",
  cheese: "dairy",
  "cheese balls": "other",
  "cheese crackers": "other",
  "cheese curds": "dairy",
  "cheese curls": "other",
  "cheese danish": "other",
  "cheese dip": "other",
  "cheese grits": "other",
  "cheese pizza": "other",
  "cheese popcorn": "other",
  "cheese puffs": "other",
  "cheese ravioli": "other",
  "cheese sauce": "other",
  "cheese slices": "dairy",
  "cheese spread": "dairy",
  "cheese stick": "dairy",
  "cheese sticks": "other",
  "cheese tortellini": "other",
  "cheese whiz": "dairy",
  cheeseburger: "meat",
  cheesecake: "other",
  cheeto: "other",
  "cheetos puff": "other",
  "cheez it": "other",
  "cheez-it": "other",
  "chelsea bun": "other",
  cherimoya: "fruit",
  cherry: "fruit",
  "cherry danish": "other",
  "cherry pepper": "produce",
  "cherry pie": "other",
  "cherry tomato": "produce", // culinary usage - grocery produce section
  "cherry turnover": "other",
  chervil: "produce",
  "cherokee purple": "produce", // Cherokee Purple heirloom tomato variety
  cheshire: "dairy",
  chestnut: "other",
  chevre: "dairy",
  chèvre: "dairy",
  "chewing gum": "other",
  chex: "other",
  "chex mix": "other",
  "chia seed": "other",
  chicharrone: "other",
  chicken: "meat",
  "chicken back": "meat",
  "chicken breast": "meat",
  "chicken breast strip": "meat",
  "chicken broth": "other",
  "chicken burger": "meat",
  "chicken cutlet": "meat",
  "chicken drummette": "meat",
  "chicken drumstick": "meat",
  "chicken giblet": "meat",
  "chicken gizzard": "meat",
  "chicken gravy": "other",
  "chicken heart": "meat",
  "chicken leg": "meat",
  "chicken leg quarter": "meat",
  "chicken liver": "meat",
  "chicken meatballs": "meat",
  "chicken mince": "meat",
  "chicken neck": "meat",
  "chicken nugget": "other",
  "chicken pot pie": "other",
  "chicken salad": "other",
  "chicken stock": "other",
  "chicken tender": "meat",
  "chicken tenders": "other", // frozen/prepared, not raw
  "chicken tenderloin": "meat",
  "chicken thigh": "meat",
  "chicken wing": "meat",
  "chicken wings": "other", // frozen/prepared, not raw
  "chicken wingette": "meat",
  chif: "produce",
  chive: "produce", // onion family herb
  "chilaca pepper": "produce",
  "chile de arbol": "produce",
  "chile relleno": "other",
  chili: "other",
  "chili bean paste": "other",
  "chili cheese fritos": "other",
  "chili flake": "other",
  "chili oil": "other",
  "chili pepper": "produce",
  "chili powder": "other",
  chimichanga: "other",
  "chinese bbq sauce": "other",
  "chinese black vinegar": "other",
  "chinese broccoli": "produce",
  "chinese cabbage": "produce",
  "chinese celery": "produce",
  "chinese cooking wine": "other",
  "chinese date": "fruit",
  "chinese eggplant": "produce",
  "chinese five spice": "other",
  "chinese leek": "produce",
  "chinese long bean": "produce",
  "chinese mustard": "produce",
  "chinese preserved vegetable": "other",
  "chinese sausage": "other",
  "chinese tea": "other",
  "chinese white vinegar": "other",
  "chinkiang vinegar": "other",
  "chioggia beet": "produce",
  chip: "other",
  "chipotle dressing": "other",
  "chipotle in adobo": "other",
  "chipotle mayo": "other",
  "chipotle pepper": "produce",
  "chipotle peppers": "other",
  "chipotle powder": "other",
  "chipotle salsa": "other",
  "chipotles in adobo sauce": "other",
  "chips ahoy": "other",
  chocolate: "other",
  "chocolate almond": "other",
  "chocolate bar": "other",
  "chocolate cake": "other",
  "chocolate cake mix": "other",
  "chocolate cheesecake": "other",
  "chocolate chip": "other",
  "chocolate chip cookie": "other",
  "chocolate chip cooky": "other",
  "chocolate cream pie": "other",
  "chocolate hazelnut spread": "other",
  "chocolate milk": "dairy",
  "chocolate milk drink": "dairy",
  "chocolate mint": "produce",
  "chocolate mousse": "other",
  "chocolate pie": "other",
  "chocolate pudding": "other",
  "chocolate rice cakes": "other",
  "chocolate syrup": "other",
  chokeberry: "fruit",
  cholula: "other",
  "cholula hot sauce": "other",
  chop: "meat", // generic meat chop
  "chopped garlic": "other",
  chorizo: "meat",
  "choux pastry": "other",
  "chow chow": "other",
  "chow mein": "other",
  "chow mein noodle": "other",
  "choy sum": "produce",
  "chrysanthemum tea": "other",
  "chuck eye roast": "meat",
  "chuck roast": "meat",
  "chunky salsa": "other",
  churro: "other",
  chutney: "other",
  ciabatta: "other",
  cilantro: "produce",
  "cilantro chutney": "other",
  "cilantro lime dressing": "other",
  "cilantro lime rice": "other",
  "cinderella pumpkin": "produce",
  cinnamon: "other",
  "cinnamon bun": "other",
  "cinnamon chip": "other",
  "cinnamon raisin bagel": "other",
  "cinnamon roll": "other",
  "cinnamon stick": "other",
  "cinnamon toast crunch": "other",
  "cipollini onion": "produce",
  citron: "fruit",
  "city ham": "meat",
  clabber: "dairy",
  clam: "seafood",
  "clarified butter": "dairy",
  clementine: "fruit",
  "cliff bar": "other",
  "clingstone peach": "fruit",
  clof: "other",
  clove: "other", // dried spice (singularized from "cloves")
  "ground clove": "other",
  "ground cloves": "other",
  "whole clove": "other",
  "whole cloves": "other",
  "clotted cream": "dairy",
  cloudberry: "fruit",
  "clover honey": "other",
  "club cracker": "other",
  "club soda": "other",
  "cluster tomato": "produce",
  cobia: "seafood",
  "coca cola": "other",
  "cocktail sauce": "other",
  "cocktail sausage": "other",
  "cocktail wiener": "other",
  cocoa: "other",
  "cocoa powder": "other",
  "cocoa puff": "other",
  coconut: "fruit",
  "coconut amino": "other",
  "coconut chip": "other",
  "coconut chutney": "other",
  "coconut cream": "other",
  "coconut cream pie": "other",
  "coconut extract": "other",
  "coconut flake": "other",
  "coconut flour": "other",
  "coconut milk": "other",
  "coconut milk beverage": "other",
  "coconut oil": "other",
  "coconut sugar": "other",
  "coconut water": "other",
  "coconut yogurt": "dairy",
  cod: "seafood",
  coffee: "other",
  "coffee bean": "other",
  "coffee cake": "other",
  "coffee cream": "dairy",
  "coffee drink": "other",
  "coffee pod": "other",
  cognac: "other",
  coke: "other",
  "coke zero": "other",
  cola: "other",
  colby: "dairy",
  "colby cheese": "dairy",
  "colby jack": "dairy",
  "cold brew": "other",
  "cold brew coffee": "other",
  "cold cut": "meat",
  "cold pressed juice": "other",
  "cole slaw": "other",
  coleslaw: "other",
  "coleslaw dressing": "other",
  "coleslaw mix": "produce",
  collard: "produce",
  "collard green": "produce",
  combo: "other",
  "comeback sauce": "other",
  "comice pear": "fruit",
  "compound butter": "dairy",
  conch: "seafood",
  "concord grape": "fruit",
  "concorde pear": "fruit",
  "condensed milk": "other",
  "confectioners sugar": "other",
  cookie: "other",
  "cookie mix": "other",
  "cooking sake": "other",
  "cooking sauce": "other",
  "cooking spray": "other",
  "cooking wine": "other",
  cooky: "other",
  "cool ranch dorito": "other",
  "cool whip": "other",
  coppa: "meat",
  "core power": "other",
  "core water": "other",
  coriander: "other",
  "coriander leaf": "produce",
  "coriander powder": "other",
  "coriander seed": "other",
  corn: "produce",
  "corn chex": "other",
  "corn chip": "other",
  "corn dog": "other",
  "corn flake": "other",
  "corn fritter": "other",
  "corn masa": "other",
  "corn muffin": "other",
  "corn muffin mix": "other",
  "corn nut": "other",
  "corn oil": "other",
  "corn on the cob": "produce",
  "corn relish": "other",
  "corn salad": "produce",
  "corn salsa": "other",
  "corn syrup": "other",
  "corn tortilla": "other",
  cornbread: "other",
  "cornbread mix": "other",
  "corned beef": "meat",
  "corned beef hash": "other",
  cornichon: "other",
  "cornish game hen": "meat",
  "cornish hen": "meat",
  cornmeal: "other",
  cornstarch: "other",
  "cortland apple": "fruit",
  "cosmic crisp apple": "fruit",
  cotija: "dairy",
  "cotija cheese": "dairy",
  "cottage cheese": "dairy",
  "cotton candy grape": "fruit",
  "country gravy": "other",
  "country ham": "meat",
  "country style rib": "meat",
  "country time lemonade": "other",
  courgette: "produce",
  couscous: "other",
  "cowboy steak": "meat",
  crab: "seafood",
  "crab leg": "seafood",
  "crab salad": "other",
  cracker: "other",
  "cracker jack": "other",
  "cracklin'": "other",
  craisin: "other",
  cranberry: "fruit",
  "cranberry juice": "other",
  "cranberry sauce": "other",
  crawfish: "seafood",
  crayfish: "seafood",
  cream: "dairy",
  "cream cheese": "dairy",
  "cream of tartar": "other",
  "cream of wheat": "other",
  "cream puff": "other",
  "cream soda": "other",
  "creamy peanut butter": "other",
  "crema mexicana": "dairy",
  "creme brulee": "other",
  "creme fraiche": "dairy",
  "crème fraîche": "dairy",
  "cremini mushroom": "produce",
  "crenshaw melon": "fruit",
  "creole seasoning": "other",
  crepe: "other",
  "crimini mushroom": "produce",
  "crispin apple": "fruit",
  "crispy garlic": "other",
  "crispy shallot": "other",
  croaker: "seafood",
  croissant: "other",
  "croissant sandwich": "other",
  "crookneck squash": "produce",
  crouton: "other",
  "crown roast of lamb": "meat",
  "crunchy cheeto": "other",
  "crunchy peanut butter": "other",
  "crush orange": "other",
  "crushed red pepper": "other",
  "crushed tomato": "other",
  "crystal hot sauce": "other",
  "crystal light": "other",
  "cubanelle pepper": "produce",
  "cubed steak": "meat",
  cucumber: "produce",
  "cucumber kimchi": "other",
  culantro: "produce",
  "cultured butter": "dairy",
  "cultured buttermilk": "dairy",
  "cultured sour cream": "dairy",
  cumin: "other",
  "cumin powder": "other",
  "cumin seed": "other",
  cupcake: "other",
  cupuacu: "fruit",
  cupuaçu: "fruit",
  "curly endive": "produce",
  "curly fry": "other",
  "curly kale": "produce",
  "curly parsley": "produce",
  currant: "other", // dried currants (like raisins), not fresh currant berries
  "curry leaf": "produce",
  "curry paste": "other",
  "curry powder": "other",
  "curry sauce": "other",
  custard: "other",
  "custard apple": "fruit",
  cuttlefish: "seafood", // cuttlefish
  daikon: "produce",
  "daikon pickle": "other",
  "daikon radish": "produce",
  "daisy sour cream": "dairy",
  dal: "other",
  "damson plum": "fruit",
  "dandelion green": "produce",
  dangmyeon: "other",
  danish: "other",
  "danish blue": "dairy",
  "danish pastry": "other",
  danmuji: "other",
  "dark cherry": "fruit",
  "dark chocolate chip": "other",
  "dark soy sauce": "other",
  dasani: "other",
  dashi: "other",
  "dashi stock": "other",
  date: "fruit",
  "david sunflower seed": "other",
  "decaf coffee": "other",
  deer: "meat", // generic venison
  "deer meat": "meat",
  "del monte fruit cup": "other",
  "deli cheese": "dairy",
  "deli ham": "other",
  "deli meat": "meat",
  "deli turkey": "other",
  "delicata squash": "produce",
  "demi glace": "other",
  "denver steak": "meat",
  "desiccated coconut": "other",
  "devil's food cake mix": "other",
  "deviled ham": "other",
  "devon cream": "dairy",
  "diablo sauce": "other",
  "diced tomato": "produce", // fresh pre-cut tomatoes
  "diced tomatoes": "other", // typically canned
  "diet coke": "other",
  "diet mountain dew": "other",
  "diet pepsi": "other",
  "diet soda": "other",
  "dijon mustard": "other",
  dill: "produce",
  "dill havarti": "dairy",
  "dill pickle": "other",
  "dill relish": "other",
  "dill weed": "produce",
  "ding dong": "other",
  "dinner roll": "other",
  "dinosaur kale": "produce",
  "distilled vinegar": "other",
  "distilled water": "other",
  "do chua": "other",
  doenjang: "other",
  "dog food": "other",
  "dog treat": "other",
  "dole fruit cup": "other",
  donut: "other",
  "donut nectarine": "fruit",
  "donut peach": "fruit",
  doogh: "dairy",
  dorito: "other",
  dot: "other",
  "dots candy": "other",
  doubanjiang: "other",
  "double cream": "dairy",
  "double gloucester": "dairy",
  douchi: "other",
  doughnut: "other",
  dorado: "seafood", // mahi-mahi / dorado fish
  "dr pepper": "other",
  "dragon fruit": "fruit",
  dragonfruit: "fruit",
  "dried apple": "other",
  "dried apple ring": "other",
  "dried apricot": "other",
  "dried banana chip": "other",
  "dried beef": "meat",
  "dried blueberry": "other",
  "dried cherry": "other",
  "dried coconut": "other",
  "dried cranberry": "other",
  "dried currant": "other",
  "dried date": "other",
  "dried edamame": "other",
  "dried fenugreek leaf": "other",
  "dried fig": "other",
  "dried fruit mix": "other",
  "dried lily bud": "other",
  "dried mango": "other",
  "dried papaya": "other",
  "dried peach": "other",
  "dried pear": "other",
  "dried pineapple": "other",
  "dried plum": "other",
  "dried pomegranate seed": "other",
  "dried prune": "other",
  "dried scallop": "other",
  "dried shiitake": "other",
  "dried shrimp": "other",
  "dried strawberry": "other",
  "dried wood ear": "other",
  "drinkable yogurt": "dairy",
  drum: "seafood",
  drumstick: "meat", // chicken drumstick (most common usage)
  "dry cat food": "other",
  "dry dog food": "other",
  "dry milk": "other",
  "dry roasted peanut": "other",
  duck: "meat",
  "duck breast": "meat",
  "duck confit": "other",
  "duck egg": "dairy",
  "duck leg": "meat",
  "duck sauce": "other",
  "duke's mayo": "other",
  "dulce de leche": "other",
  dulse: "other",
  "dum dum": "other",
  dumpling: "other",
  "dumpling wrapper": "other",
  "dungeness crab": "seafood",
  "dunkin iced coffee": "other",
  durian: "fruit",
  "dutch process cocoa": "other",
  echalote: "produce",
  eclair: "other",
  edam: "dairy",
  edamame: "produce",
  eel: "seafood",
  egg: "dairy",
  "egg beater": "dairy",
  "egg fruit": "fruit",
  "egg mcmuffin": "other",
  "egg noodle": "other",
  "egg roll": "other",
  "egg roll wrapper": "other",
  "egg salad": "other",
  "egg substitute": "dairy",
  "egg white": "dairy",
  "eggo waffle": "other",
  eggplant: "produce",
  "el yucateco": "other",
  "elbow macaroni": "other",
  elderberry: "fruit",
  "electrolyte powder": "other",
  "elephant ear": "other",
  "elephant garlic": "produce",
  elk: "meat",
  "elk roast": "meat",
  "elk steak": "meat",
  emmental: "dairy",
  emmentaler: "dairy",
  empanada: "other",
  "empire apple": "fruit",
  emu: "meat",
  enchilada: "other",
  "enchilada sauce": "other",
  endive: "produce",
  "energy bar": "other",
  "energy drink": "other",
  "english cheddar": "dairy",
  "english cucumber": "produce",
  "english cut short rib": "meat",
  "english muffin": "other",
  "english pea": "produce",
  "enoki mushroom": "produce",
  enokitake: "produce",
  ensure: "other",
  "envy apple": "fruit",
  epazote: "produce",
  epoiss: "dairy",
  eryngii: "produce",
  escarole: "produce",
  espresso: "other",
  "espresso drink": "other",
  "essentia water": "other",
  etrog: "fruit",
  "european butter": "dairy",
  "european style yogurt": "dairy",
  "evaporated milk": "dairy",
  "everything bagel": "other",
  evian: "other",
  "evolution fresh": "other",
  "extra firm tofu": "other",
  "extra large egg": "dairy",
  "extra lean ground beef": "meat",
  "extra sharp cheddar": "dairy",
  "extra virgin olive oil": "other",
  "eye of round": "meat",
  "fairlife milk": "dairy",
  "fairlife protein shake": "other",
  "fairy tale eggplant": "produce",
  "fairytale pumpkin": "produce",
  fajita: "other",
  "fajita seasoning": "other",
  falafel: "other",
  "falafel mix": "other",
  "fancy ketchup": "other",
  fanta: "other",
  farfalle: "other",
  "farmer cheese": "dairy",
  "farmers cheese": "dairy",
  farro: "other",
  "fat free milk": "dairy",
  feijoa: "fruit",
  fennel: "produce",
  "fennel bulb": "produce",
  "fennel seed": "other",
  "fenugreek leaf": "other",
  "fenugreek seed": "other",
  "fermented black bean": "other",
  "fermented soybean": "other",
  feta: "dairy",
  "feta cheese": "dairy",
  fettuccine: "other",
  "fettuccine alfredo": "other",
  "fiber supplement": "other",
  "field pumpkin": "produce",
  fig: "fruit",
  "fig newton": "other",
  "fiji water": "other",
  filet: "meat",
  "filet mignon": "meat",
  fillet: "seafood", // generic fish fillet
  filmjölk: "dairy",
  "finger lime": "fruit",
  "fingerling potato": "produce",
  "fire roasted tomato": "other",
  "fire sauce": "other",
  "firm tofu": "other",
  fish: "seafood", // generic fish
  "fish fingers": "other",
  "fish food": "other",
  "fish oil": "other",
  "fish sauce": "other",
  "fish sticks": "other",
  "five spice": "other",
  "five spice powder": "other",
  "five-spice": "other",
  "five-spice powder": "other",
  "chinese five-spice": "other",
  "flaky biscuit": "other",
  "flamin hot cheeto": "other",
  flan: "other",
  "flank steak": "meat",
  "flanken short rib": "meat",
  "flat cut brisket": "meat",
  "flat iron steak": "meat",
  "flat leaf parsley": "produce",
  "flat leaf spinach": "produce",
  "flat nectarine": "fruit",
  "flat peach": "fruit",
  flatbread: "other",
  "flavored milk": "dairy",
  "flavored water": "other",
  "flax milk": "other",
  "flax seed": "other",
  flounder: "seafood",
  flour: "other",
  "flour tortilla": "other",
  focaccia: "other",
  fontina: "dairy",
  "fontina cheese": "dairy",
  "food coloring": "other",
  "forelle pear": "fruit",
  "fortune cooky": "other",
  "frank's redhot": "other",
  frankfurter: "meat",
  "franks red hot": "other",
  frappuccino: "other",
  "free range egg": "dairy",
  "freestone peach": "fruit",
  "french bean": "produce",
  "french bread": "other",
  "french breakfast radish": "produce",
  "french butter": "dairy",
  "french dressing": "other",
  "french feta": "dairy",
  "french fried onion": "other",
  "french fry": "other",
  "french onion dip": "other",
  "french silk pie": "other",
  "french tarragon": "produce",
  "french toast": "other",
  "french toast stick": "other",
  "french's mustard": "other",
  "fresh apricot": "fruit",
  "fresh bamboo shoot": "produce",
  "fresh basil": "produce",
  "fresh bay leaf": "produce",
  "fresh cayenne": "produce",
  "fresh cherry": "fruit",
  "fresh cilantro": "produce",
  "fresh coconut": "fruit",
  "fresh cranberry": "fruit",
  "fresh curry leaf": "produce",
  "fresh dill": "produce",
  "fresh edamame": "produce",
  "fresh ginger": "produce",
  "fresh gnocchi": "other",
  "fresh goat cheese": "dairy",
  "fresh guacamole": "other",
  "fresh herb": "produce",
  "fresh kimchi": "other",
  "fresh marjoram": "produce",
  "fresh mint": "produce",
  "fresh mozzarella": "dairy",
  "fresh oregano": "produce",
  "fresh parsley": "produce",
  "fresh pho noodle": "other",
  "fresh raman": "other",
  "fresh rosemary": "produce",
  "fresh sage": "produce",
  "fresh salsa": "other",
  "fresh tarragon": "produce",
  "fresh thyme": "produce",
  "fresh turmeric": "produce",
  "fresh udon": "other",
  "fresh water chestnut": "produce",
  "fresno pepper": "produce",
  "fried chicken": "other",
  "fried garlic": "other",
  "fried onion": "other",
  "fried plantain": "other",
  "fried rice": "other",
  "fried shallot": "other",
  "fried tofu": "other",
  "fried wonton": "other",
  frisee: "produce",
  frito: "other",
  fritter: "other",
  "frog leg": "meat",
  "fromage blanc": "dairy",
  "froot loop": "other",
  "frosted flake": "other",
  "frosted mini wheat": "other",
  frosting: "other",
  "frozen acai": "other",
  "frozen acorn squash": "other",
  "frozen appetizer": "other",
  "frozen asparagus": "other",
  "frozen bacon": "other",
  "frozen baked potato": "other",
  "frozen baked ziti": "other",
  "frozen banana": "other",
  "frozen bao bun": "other",
  "frozen beef and broccoli": "other",
  "frozen berry": "other",
  "frozen beyond burger": "other",
  "frozen black bean burger": "other",
  "frozen blackberry": "other",
  "frozen blintze": "other",
  "frozen blueberry": "other",
  "frozen boneless wing": "other",
  "frozen breaded fish": "other",
  "frozen breakfast bowl": "other",
  "frozen breakfast burrito": "other",
  "frozen breakfast sandwich": "other",
  "frozen breakfast sausage": "other",
  "frozen broccoli": "other",
  "frozen brussels sprout": "other",
  "frozen buffalo wing": "other",
  "frozen burger patty": "other",
  "frozen burrito": "other",
  "frozen butter chicken": "other",
  "frozen butternut squash": "other",
  "frozen calamari": "other",
  "frozen calzone": "other",
  "frozen cannelloni": "other",
  "frozen carbonara": "other",
  "frozen carrot": "other",
  "frozen cauliflower": "other",
  "frozen cauliflower rice": "other",
  "frozen cheese bites": "other",
  "frozen cheese sticks": "other",
  "frozen cheesecake": "other",
  "frozen cherry": "other",
  "frozen chicken cordon bleu": "other",
  "frozen chicken finger": "other",
  "frozen chicken kiev": "other",
  "frozen chicken nugget": "other",
  "frozen chicken parmesan": "other",
  "frozen chicken patty": "other",
  "frozen chicken strip": "other",
  "frozen chicken taquito": "other",
  "frozen chicken tender": "other",
  "frozen chicken tikka masala": "other",
  "frozen chicken wing": "other",
  "frozen chimichanga": "other",
  "frozen cocktail meatballs": "other",
  "frozen coconut shrimp": "other",
  "frozen cod": "seafood",
  "frozen cookie dough": "other",
  "frozen corn": "other",
  "frozen corn dog": "other",
  "frozen crab cake": "other",
  "frozen crab rangoon": "other",
  "frozen crinkle fry": "other",
  "frozen croissant sandwich": "other",
  "frozen curly fry": "other",
  "frozen dinner": "other",
  "frozen dumpling": "other",
  "frozen edamame": "other",
  "frozen egg roll": "other",
  "frozen egg sandwich": "other",
  "frozen eggplant parmesan": "other",
  "frozen empanada": "other",
  "frozen enchilada": "other",
  "frozen fajita vegetable": "other",
  "frozen fettuccine alfredo": "other",
  "frozen fish fillets": "other",
  "frozen fish sticks": "other",
  "frozen flauta": "other",
  "frozen french fry": "other",
  "frozen french toast": "other",
  "frozen fried rice": "other",
  "frozen fruit": "other",
  "frozen fruit blend": "other",
  "frozen fry": "other",
  "frozen general tso chicken": "other",
  "frozen gnocchi": "other",
  "frozen green bean": "other",
  "frozen gyoza": "other",
  "frozen hamburger patty": "other",
  "frozen hash brown": "other",
  "frozen hash brown patty": "other",
  "frozen hors d'oeuvre": "other",
  "frozen hot dog": "other",
  "frozen hot pocket": "other",
  "frozen impossible burger": "other",
  "frozen italian meatballs": "other",
  "frozen jalapeño bite": "other",
  "frozen jalapeno popper": "other",
  "frozen jalapeño popper": "other",
  "frozen kale": "other",
  "frozen knish": "other",
  "frozen kung pao chicken": "other",
  "frozen lasagna": "other",
  "frozen lean pocket": "other",
  "frozen lima bean": "other",
  "frozen lo mein": "other",
  "frozen loaded potato skin": "other",
  "frozen lobster tail": "seafood",
  "frozen mac and cheese": "other",
  "frozen mac and cheese bites": "other",
  "frozen mango": "other",
  "frozen manicotti": "other",
  "frozen mashed potato": "other",
  "frozen meatballs": "other",
  "frozen meatloaf": "other",
  "frozen mini corn dog": "other",
  "frozen mini meatballs": "other",
  "frozen mixed berry": "other",
  "frozen mixed vegetable": "other",
  "frozen mongolian beef": "other",
  "frozen mozzarella stick": "other",
  "frozen okra": "other",
  "frozen onion ring": "other",
  "frozen orange chicken": "other",
  "frozen pad thai": "other",
  "frozen pakora": "other",
  "frozen pancake": "other",
  "frozen panini": "other",
  "frozen pea": "other",
  "frozen peach": "other",
  "frozen peas and carrot": "other",
  "frozen penne pasta": "other",
  "frozen pie": "other",
  "frozen pierogy": "other",
  "frozen pigs in a blanket": "other",
  "frozen pineapple": "other",
  "frozen pizza": "other",
  "frozen pizza roll": "other",
  "frozen popcorn chicken": "other",
  "frozen popcorn shrimp": "other",
  "frozen pot pie": "other",
  "frozen pot roast": "other",
  "frozen potato wedge": "other",
  "frozen potsticker": "other",
  "frozen quesadilla": "other",
  "frozen quiche": "other",
  "frozen raspberry": "other",
  "frozen ravioli": "other",
  "frozen riced cauliflower": "other",
  "frozen roasted potato": "other",
  "frozen salisbury steak": "other",
  "frozen salmon": "seafood",
  "frozen samosa": "other",
  "frozen sausage": "other",
  "frozen sausage biscuit": "other",
  "frozen sausage link": "other",
  "frozen sausage patty": "other",
  "frozen scallop": "seafood",
  "frozen sesame chicken": "other",
  "frozen shrimp": "seafood",
  "frozen shumai": "other",
  "frozen smoothie mix": "other",
  "frozen spaghetti and meatballs": "other",
  "frozen spinach": "other",
  "frozen spinach artichoke bites": "other",
  "frozen spring roll": "other",
  "frozen steak fry": "other",
  "frozen steamed bun": "other",
  "frozen stir fry": "other",
  "frozen stir fry vegetable": "other",
  "frozen strawberry": "other",
  "frozen stromboli": "other",
  "frozen stuffed cabbage": "other",
  "frozen stuffed peppers": "other",
  "frozen stuffed shell": "other",
  "frozen succotash": "other",
  "frozen swedish meatballs": "other",
  "frozen sweet and sour chicken": "other",
  "frozen sweet potato fry": "other",
  "frozen tamale": "other",
  "frozen taquito": "other",
  "frozen tater tot": "other",
  "frozen teriyaki chicken": "other",
  "frozen tilapia": "seafood",
  "frozen tortellini": "other",
  "frozen turkey breast": "other",
  "frozen turkey burger": "other",
  "frozen turkey dinner": "other",
  "frozen turkey meatballs": "other",
  "frozen twice baked potato": "other",
  "frozen udon": "other",
  "frozen vegetable": "other",
  "frozen veggie burger": "other",
  "frozen waffle": "other",
  "frozen waffle fry": "other",
  "frozen wonton": "other",
  "frozen yogurt": "other",
  "frozen ziti": "other",
  "frozen zoodle": "other",
  "frozen zucchini noodle": "other",
  fruit: "fruit", // generic fruit
  "fruit by the foot": "other",
  "fruit cup": "other",
  "fruit filled cooky": "other",
  "fruit leather": "other",
  "fruit loop": "other",
  "fruit punch": "other",
  "fruit roll up": "other",
  "fruit snack": "other",
  "fruit strip": "other",
  "fruit tart": "other",
  "fruit yogurt": "dairy",
  "fry sauce": "other",
  fudgesicle: "other",
  "fuji apple": "fruit",
  "fun dip": "other",
  "funnel cake": "other",
  funyun: "other",
  furikake: "other",
  fusilli: "other",
  "fuyu persimmon": "fruit",
  "fuzzy gourd": "produce",
  "fuzzy melon": "produce",
  "gai choy": "produce",
  "gai lan": "produce",
  "gala apple": "fruit",
  galangal: "produce",
  "galbi sauce": "other",
  "galia melon": "fruit",
  "garam masala": "other",
  "garden pea": "produce",
  "garden salad": "other",
  gari: "other",
  garlic: "produce",
  "garlic aioli": "other",
  "garlic butter": "dairy",
  "garlic chif": "produce",
  "garlic clof": "produce",
  "garlic hummus": "other",
  "garlic naan": "other",
  "garlic powder": "other",
  "garlic salt": "other",
  "garlic scape": "produce",
  "garnet sweet potato": "produce",
  gatorade: "other",
  gelatin: "other",
  gelato: "other",
  "general tso sauce": "other",
  "genoa salami": "meat",
  "genovese pesto": "other",
  geoduck: "seafood", // geoduck clam
  ghee: "dairy",
  gherkin: "other",
  "ghost pepper": "produce",
  "ghost pepper sauce": "other",
  gin: "other",
  ginger: "produce",
  "ginger ale": "other",
  "ginger dressing": "other",
  "ginger gold apple": "fruit",
  "ginger paste": "other",
  "ginger powder": "other",
  "ginger root": "produce",
  "girl scout cooky": "other",
  "glass noodles": "other",
  "glazed donut": "other",
  "globe artichoke": "produce",
  "globe eggplant": "produce",
  gloucester: "dairy",
  "gluten free soy sauce": "other",
  "glutinous rice": "other",
  gnocchi: "other",
  "goat cheese": "dairy",
  "goat cheese log": "dairy",
  gobo: "produce",
  gochugaru: "other",
  "gochugaru pepper": "produce",
  gochujang: "other",
  "goji berry": "fruit",
  "gold kiwi": "fruit",
  "gold peak tea": "other",
  "golden beet": "produce",
  "golden berry": "fruit",
  "golden delicious apple": "fruit",
  "golden kiwi": "fruit",
  "golden needle": "other",
  "golden needle mushroom": "produce",
  "golden raisin": "other",
  "golden turnip": "produce",
  goldfish: "other",
  "goldfish crackers": "other",
  goose: "meat",
  "goose breast": "meat",
  gooseberry: "fruit",
  gorgonzola: "dairy",
  gouda: "dairy",
  "gouda cheese": "dairy",
  "graffiti eggplant": "produce",
  "graham cracker": "other",
  "grana padano": "dairy",
  "grands biscuit": "other",
  "granny smith apple": "fruit",
  granola: "other",
  "granola bar": "other",
  "granulated sugar": "other",
  grape: "fruit",
  "grape crush": "other",
  "grape jelly": "other",
  "grape juice": "other",
  "grape nut": "other",
  "grape soda": "other",
  "grape tomato": "produce", // culinary usage
  grapefruit: "fruit",
  "grapefruit juice": "other",
  "grapeseed oil": "other",
  "grass fed milk": "dairy",
  gravy: "other",
  "gravy mix": "other",
  "gravy packet": "other",
  "greek dressing": "other",
  "greek feta": "dairy",
  "greek salad": "other",
  "greek style yogurt": "dairy",
  "greek yogurt": "dairy",
  "green anjou pear": "fruit",
  "green apple": "fruit",
  "green asparagus": "produce",
  "green bean": "produce",
  "green bell pepper": "produce",
  "green cabbage": "produce",
  "green cardamom": "other",
  "green cauliflower": "produce",
  "green chili": "produce",
  "green curry paste": "other",
  "green enchilada sauce": "other",
  "green goddess dressing": "other",
  "green grape": "fruit",
  "green jalapeno": "produce",
  "green kiwi": "fruit",
  "green leaf lettuce": "produce",
  "green olif": "other",
  "green onion": "produce",
  "green papaya": "fruit",
  "green plantain": "produce",
  "green plum": "fruit",
  "green tea": "other",
  "green tea powder": "other",
  "green tomato": "produce",
  "green zucchini": "produce",
  grenadine: "other",
  "grey poupon": "other",
  grit: "other",
  "ground beef": "meat",
  "ground bison": "meat",
  "ground chicken": "meat",
  "ground chuck": "meat",
  "ground cinnamon": "other",
  "ground coffee": "other",
  "ground coriander": "other",
  "ground cumin": "other",
  "ground lamb": "meat",
  "ground pork": "meat",
  "ground round": "meat",
  "ground sirloin": "meat",
  "ground turkey": "meat",
  "ground turmeric": "other",
  "ground veal": "meat",
  "ground venison": "meat",
  grouper: "seafood",
  gruyere: "dairy",
  gruyère: "dairy",
  "gruyere cheese": "dairy",
  "gt's kombucha": "other",
  guacamole: "other",
  guanabana: "fruit",
  guanciale: "meat",
  guava: "fruit",
  "guayaki yerba mate": "other",
  "gulden's mustard": "other",
  gum: "other",
  gumdrop: "other",
  gummy: "other",
  "gummy bear": "other",
  "gummy snack": "other",
  "gummy worm": "other",
  gusher: "other",
  habanero: "produce",
  "habanero pepper": "produce",
  "habanero salsa": "other",
  "habanero sauce": "other",
  "hachiya persimmon": "fruit",
  haddock: "seafood",
  haggi: "meat",
  "hakurei turnip": "produce",
  "half & half": "dairy",
  "half and half": "dairy",
  halibut: "seafood",
  halloumi: "dairy",
  ham: "meat",
  "ham hock": "meat",
  "ham steak": "meat",
  hamachi: "seafood",
  hamburger: "meat",
  "hamburger bun": "other",
  "hamburger patty": "meat",
  "hanger steak": "meat",
  "hannah sweet potato": "produce",
  "hard salami": "meat",
  "hard taco shell": "other",
  "haribo gummy bear": "other",
  "haricot vert": "produce",
  harissa: "other",
  "harmless harvest": "other",
  "hash brown": "other",
  "hashbrown potato": "other",
  "hatch chile": "produce",
  "hatch pepper": "produce",
  havarti: "dairy",
  "havarti cheese": "dairy",
  "hawaiian punch": "other",
  hazelnut: "other",
  "hazelnut milk": "other",
  "head cheese": "meat",
  "health ade kombucha": "other",
  "heavy cream": "dairy",
  "heavy whipping cream": "dairy",
  "heinz ketchup": "other",
  "heirloom tomato": "produce", // culinary usage
  "hellmann's mayo": "other",
  "hemp milk": "dairy",
  "hemp seed": "other",
  "hen of the wood": "produce",
  "herb butter": "dairy",
  "herbal tea": "other",
  "herbs de provence": "other",
  herring: "seafood",
  "herrs chip": "other",
  hershey: "other",
  "hibiscus tea": "other",
  "hidden valley ranch": "other",
  hijiki: "other",
  "himalayan salt": "other",
  hing: "other",
  hirame: "seafood",
  "ho ho": "other",
  hoagie: "other",
  "hoagie roll": "other",
  hoisin: "other", // hoisin sauce shorthand
  "hoisin sauce": "other",
  "holy basil": "produce",
  hominy: "other",
  "honduran crema": "dairy",
  "honest tea": "other",
  honey: "other",
  "honey bbq sauce": "other",
  "honey bun": "other",
  "honey bunches of oat": "other",
  "honey crisp apple": "fruit",
  "honey ham": "meat",
  "honey mustard": "other",
  "honey mustard dressing": "other",
  "honey nut cheerio": "other",
  "honey roasted peanut": "other",
  "honey turkey": "meat",
  "honeycrisp apple": "fruit",
  honeydew: "fruit",
  "honeydew melon": "fruit",
  horchata: "other",
  "hormel bacon": "meat",
  "horned melon": "fruit",
  horseradish: "produce",
  "horseradish root": "produce",
  "hot cheeto": "other",
  "hot chocolate": "other",
  "hot cocoa": "other",
  "hot cocoa mix": "other",
  "hot dog": "meat",
  "hot dog bun": "other",
  "hot dog relish": "other",
  "hot fudge": "other",
  "hot italian sausage": "meat",
  "hot mustard": "other",
  "hot pot base": "other",
  "hot pot seasoning": "other",
  "hot salsa": "other",
  "hot sauce": "other",
  "hot taco sauce": "other",
  "hot tamale": "other",
  "hp sauce": "other",
  "hubbard squash": "produce",
  huckleberry: "fruit",
  hummus: "other",
  "hungarian wax pepper": "produce",
  "hungry jack": "other",
  "husk tomato": "produce",
  "huy fong sriracha": "other",
  "ibarra chocolate": "other",
  "ice cream": "other",
  "ice cream bar": "other",
  "ice cream sandwich": "other",
  "iceberg lettuce": "produce",
  "iced coffee": "other",
  "iced tea": "other",
  "icelandic yogurt": "dairy",
  icing: "other",
  "idaho potato": "produce",
  ika: "seafood",
  "imitation bacon bit": "other",
  "impossible burger": "other",
  "indian cheese": "dairy",
  "infant formula": "other",
  "instant coffee": "other",
  "instant grit": "other",
  "instant mashed potato": "other",
  "instant oatmeal": "other",
  "instant polenta": "other",
  "instant pudding": "other",
  "instant raman": "other",
  "instant rice": "other",
  "instant yeast": "other",
  ipa: "other",
  ikura: "seafood", // salmon roe
  "irish butter": "dairy",
  "irish cheddar": "dairy",
  "iron supplement": "other",
  "italian bean": "produce",
  "italian bread": "other",
  "italian breadcrumbs": "other",
  "italian cold cut": "meat",
  "italian dressing": "other",
  "italian eggplant": "produce",
  "italian meatballs": "meat",
  "italian parsley": "produce",
  "italian plum": "fruit",
  "italian sausage": "meat",
  "italian seasoning": "other",
  "italian vinaigrette": "other",
  iwashi: "seafood",
  "jack links jerky": "other",
  jackfruit: "fruit",
  jalapeno: "produce",
  jalapeño: "produce",
  "jalapeno chip": "other",
  "jalapeno havarti": "dairy", // jalapeno havarti cheese
  "jalapeno pepper": "produce",
  "jalapeño pepper": "produce",
  "jalapeno popper": "other",
  "jalapeños in jar": "other",
  jam: "other",
  "jamaica drink": "other",
  "japanese breadcrumbs": "other",
  "japanese cucumber": "produce",
  "japanese eggplant": "produce",
  "japanese mayo": "other",
  "japanese pickle": "other",
  "japanese pumpkin": "produce",
  "japanese seven spice": "other",
  "japanese sweet potato": "produce",
  "japchae noodle": "other",
  jarlsberg: "dairy",
  "jar of artichoke hearts": "other", // processed, not raw
  "jar of horseradish": "other", // processed, not raw
  "jar of olives": "other", // processed, not raw fruit
  "jar of pickles": "other", // processed, not raw
  "jar of wasabi": "other", // processed, not raw
  "jarrahdale pumpkin": "produce",
  "jasmine rice": "other",
  "jasmine tea": "other",
  jawbreaker: "other",
  "jazz apple": "fruit",
  "jell-o": "other",
  jello: "other",
  "jello cup": "other",
  "jello pudding": "other",
  jelly: "other",
  "jelly bean": "other",
  "jelly donut": "other",
  "jerk seasoning": "other",
  "jerusalem artichoke": "produce",
  "jewel sweet potato": "produce",
  jicama: "produce",
  "jiffy mix": "other",
  jimmy: "other",
  "jimmy dean breakfast": "other",
  "john dory": "seafood",
  "jolly rancher": "other",
  "jonagold apple": "fruit",
  "jonathan apple": "fruit",
  juice: "other",
  "juice box": "other",
  "juice pouch": "other",
  jujube: "fruit",
  jujubes: "other", // candy, not fruit
  "juniper berry": "fruit",
  "k-cup": "other",
  "kabocha squash": "produce",
  "kaffir lime": "fruit",
  "kaffir lime leaf": "produce",
  "kaiser roll": "other",
  "kalamata olif": "other",
  "kalbi marinade": "other",
  kale: "produce",
  "kale chip": "other",
  "kale salad mix": "produce",
  "kansas city bbq sauce": "other",
  "kansas city strip": "meat",
  kapi: "other",
  karela: "produce",
  "kasuri methi": "other",
  katsuobushi: "other",
  kaymak: "dairy",
  kefir: "dairy",
  kerrygold: "dairy",
  ketchup: "other",
  "kettle chip": "other",
  "kettle corn": "other",
  kevita: "other",
  "kewpie mayo": "other",
  "key lime": "fruit",
  "key lime pie": "other",
  khoa: "dairy",
  kielbasa: "meat",
  "kikkoman soy sauce": "other",
  "kim snack": "other",
  kimchi: "other",
  "kind bar": "other",
  "king crab": "seafood",
  "king oyster mushroom": "produce",
  "king trumpet mushroom": "produce",
  kingfish: "seafood",
  kinmedai: "seafood",
  "kirby cucumber": "produce",
  "kit kat": "other",
  kiwano: "fruit",
  kiwi: "fruit",
  "kiwi berry": "fruit",
  "kiwi fruit": "fruit",
  kiwifruit: "fruit",
  kix: "other",
  kkaennip: "produce",
  kkakdugi: "other",
  "klondike bar": "other",
  kohlrabi: "produce",
  kombu: "other",
  kombucha: "other",
  konjac: "other",
  konnyaku: "other",
  "kool aid": "other",
  "kool-aid": "other",
  "korean bbq sauce": "other",
  "korean chili": "produce",
  "korean chili flake": "other",
  "korean chili paste": "other",
  "korean instant noodle": "other",
  "korean melon": "fruit",
  "korean pear": "fruit",
  "korean pickle": "other",
  "korean radish": "produce",
  "korean red pepper flakes": "other",
  "korean rice cakes": "other",
  "korean soybean paste": "other",
  "korma sauce": "other",
  "kosher pickle": "other",
  "kosher salt": "other",
  "kraft bbq sauce": "other",
  "kraft mac and cheese": "other",
  "kraft mayo": "other",
  krusteaz: "other",
  kumato: "produce",
  kumquat: "fruit",
  "kung pao sauce": "other",
  labne: "dairy",
  labneh: "dairy",
  "lacinato kale": "produce",
  lacroix: "other",
  lactaid: "dairy",
  "lactose free milk": "dairy",
  "lacy swiss": "dairy",
  "lady apple": "fruit",
  "laffy taffy": "other",
  lager: "other",
  lamb: "meat",
  "lamb breast": "meat",
  "lamb burger": "meat",
  "lamb chop": "meat",
  "lamb gyro meat": "meat",
  "lamb kabob": "meat",
  "lamb kebab": "meat",
  "lamb kidney": "meat",
  "lamb liver": "meat",
  "lamb loin": "meat",
  "lamb loin chop": "meat",
  "lamb neck": "meat",
  "lamb rack": "meat",
  "lamb rib chop": "meat",
  "lamb riblets": "meat",
  "lamb ribs": "meat",
  "lamb shank": "meat",
  "lamb shoulder": "meat",
  "lamb shoulder chop": "meat",
  "lamb shoulder roast": "meat",
  "lamb sirloin": "meat",
  "lamb stew meat": "meat",
  "lamb tenderloin": "meat",
  "lamb tongue": "meat",
  "lambs lettuce": "produce",
  lancashire: "dairy",
  langostino: "seafood", // langostino lobster
  "lap cheong": "other",
  "lap chong": "other",
  lardo: "meat",
  "large curd cottage cheese": "dairy",
  "large egg": "dairy",
  lasagna: "other",
  "lasagna noodle": "other",
  "lasagna sheet": "other",
  lassi: "dairy",
  latte: "other",
  "laughing cow": "dairy",
  lavash: "other",
  "lawrys seasoned salt": "other",
  "lays chip": "other",
  "lea & perrin": "other",
  "lean ground beef": "meat",
  "lean ground turkey": "meat",
  lebni: "dairy",
  leek: "produce",
  leg: "meat", // generic meat leg
  "leg of lamb": "meat",
  leicester: "dairy",
  lemon: "fruit",
  "lemon basil": "produce",
  "lemon cake mix": "other",
  "lemon cucumber": "produce",
  "lemon extract": "other",
  "lemon grass": "produce",
  "lemon meringue pie": "other",
  "lemon pepper": "other",
  "lemon tart": "other",
  "lemon thyme": "produce",
  "lemon verbena": "produce",
  lemonade: "other",
  lemongrass: "produce",
  "lemongrass stalk": "produce",
  lentil: "other",
  lettuce: "produce",
  licorice: "other",
  "life cereal": "other",
  "life saver": "other",
  "light beer": "other",
  "light cream": "dairy",
  "light mayo": "other",
  "light sour cream": "dairy",
  "light soy sauce": "other",
  "lil smoky": "other",
  "lily bud": "other",
  "lima bean": "produce", // fresh lima bean
  limburger: "dairy",
  lime: "fruit",
  limeade: "other",
  limequat: "fruit",
  lingcod: "seafood",
  lingonberry: "fruit",
  linguica: "meat",
  linguine: "other",
  "lions mane mushroom": "produce",
  "lipton iced tea": "other",
  "liquid amino": "other",
  "liquid egg white": "dairy",
  litchi: "fruit",
  "little debbie": "other",
  "little gem lettuce": "produce",
  liverwurst: "meat",
  "lo mein": "other",
  "lo mein noodle": "other",
  "loaded baked potato": "other",
  lobster: "seafood",
  "lobster salad": "other",
  "lobster tail": "seafood",
  loganberry: "fruit",
  "loin chop": "meat",
  lollipop: "other",
  "london broil": "meat",
  "long bean": "produce",
  "long grain rice": "other",
  longan: "fruit",
  longaniza: "meat",
  loquat: "fruit",
  "lotus root": "produce",
  "louisiana hot sauce": "other",
  lovage: "produce",
  "low fat sour cream": "dairy",
  "low fat yogurt": "dairy",
  "low moisture mozzarella": "dairy",
  "low sodium soy sauce": "other",
  "lucky charm": "other",
  "luna bar": "other",
  "lunch meat": "meat",
  lunchable: "other",
  lychee: "fruit",
  "m&m": "other",
  "mac and cheese": "other",
  "macadamia milk": "other",
  "macadamia nut": "other",
  macaron: "other",
  macaroni: "other",
  "macaroni and cheese": "other",
  "macaroni salad": "other",
  macaroon: "other",
  mace: "other",
  machaca: "meat",
  mache: "produce",
  mackerel: "seafood",
  "madras curry sauce": "other",
  maguro: "seafood",
  "mahi mahi": "seafood",
  mahon: "dairy",
  maitake: "produce",
  "makrut lime": "fruit",
  "makrut lime leaf": "produce",
  malanga: "produce",
  "malt vinegar": "other",
  "malted milk": "other",
  mamey: "fruit",
  "mamey sapote": "fruit",
  manchego: "dairy",
  "manchego cheese": "dairy",
  mandarin: "fruit",
  "mandarin orange": "fruit",
  "mandarin orange cup": "other",
  mango: "fruit",
  "mango chutney": "other",
  "mango lassi": "dairy",
  "mango powder": "other",
  "mango salsa": "other",
  mangosteen: "fruit",
  manioc: "produce",
  "manuka honey": "other",
  "maple syrup": "other",
  "mapo tofu sauce": "other",
  margarine: "dairy",
  "margarita mix": "other",
  marinara: "other",
  "marinara sauce": "other",
  "marinated artichoke": "other",
  marionberry: "fruit",
  marjoram: "produce",
  marmalade: "other",
  "marrow bone": "meat",
  marshmallow: "other",
  "masa harina": "other",
  masago: "seafood", // capelin roe
  mascarpone: "dairy",
  "mascarpone cheese": "dairy",
  "mashed potato": "other",
  "mashed potato mix": "other",
  "massaman curry paste": "other",
  "matcha powder": "other",
  mate: "other",
  matsoni: "dairy",
  matsutake: "produce",
  "maui onion": "produce",
  mawa: "dairy",
  mayo: "other",
  mayonnaise: "other",
  "maytag blue": "dairy",
  "mccafe iced coffee": "other",
  "mcintosh apple": "fruit",
  "meal replacement shake": "other",
  "meat loaf": "meat",
  "meat ravioli": "other",
  "meat sticks": "meat",
  meatball: "meat",
  meatballs: "meat",
  meatloaf: "other",
  "meatloaf mix": "meat",
  "medium egg": "dairy",
  "medium grain rice": "other",
  "medium roast beef": "meat",
  "medium salsa": "other",
  medlar: "fruit",
  "melba toast": "other",
  melon: "fruit",
  "memphis bbq sauce": "other",
  mento: "other",
  menudo: "other",
  mesclun: "produce",
  metamucil: "other",
  "methi seed": "other",
  "mexican chocolate": "other",
  "mexican chorizo": "meat",
  "mexican crema": "dairy",
  "mexican oregano": "produce",
  "mexican rice": "other",
  "mexican turnip": "produce",
  "meyer lemon": "fruit",
  "microwave popcorn": "other",
  "mike and ike": "other",
  "milano cooky": "other",
  "mild cheddar": "dairy",
  "mild salsa": "other",
  "mild taco sauce": "other",
  milk: "dairy",
  "milk chocolate chips": "other",
  "milk powder": "other",
  "milk tea": "other",
  "milky way": "other",
  millet: "other",
  "minced garlic": "other",
  "mini bell pepper": "produce",
  "mini cucumber": "produce",
  "mini pumpkin": "produce",
  "mini watermelon": "fruit",
  microgreens: "produce", // young vegetable greens
  minneola: "fruit",
  mint: "produce",
  "mint chutney": "other",
  mints: "other", // candy, not herb
  "minute maid lemonade": "other",
  "minute rice": "other",
  "minute steak": "meat",
  "mirabelle plum": "fruit",
  mirin: "other",
  mirliton: "produce",
  miso: "other",
  "miso dressing": "other",
  "miso paste": "other",
  "mixed fruit cup": "other",
  "mixed green": "produce",
  "mixed nut": "other",
  mizuna: "produce",
  mocha: "other",
  mochi: "other",
  molass: "other",
  mole: "other",
  "mole negro": "other",
  "mole poblano": "other",
  "mole sauce": "other",
  monkfish: "seafood",
  monster: "other",
  "monster energy": "other",
  "monterey jack": "dairy",
  "moon drop grape": "fruit",
  morel: "produce",
  "morel mushroom": "produce",
  "morello cherry": "fruit",
  mortadella: "meat",
  "mott's applesauce": "other",
  "mott's fruit snack": "other",
  mound: "other",
  "mountain dew": "other",
  mousse: "other",
  mozzarella: "dairy",
  "mozzarella cheese": "dairy",
  "mozzarella di bufala": "dairy",
  "mozzarella stick": "other",
  "mr pibb": "other",
  mu: "produce",
  "muddy buddy": "other",
  muenster: "dairy",
  "muenster cheese": "dairy",
  muesli: "other",
  muffin: "other",
  "muffin mix": "other",
  "mug root beer": "other",
  "mul kimchi": "other",
  mulberry: "fruit",
  mullet: "seafood",
  "multi grain bread": "other",
  "multigrain chip": "other",
  multivitamin: "other",
  "mung bean sprout": "produce",
  münster: "dairy",
  "muscat grape": "fruit",
  "muscle milk": "other",
  mushroom: "produce",
  "mushroom gravy": "other",
  muskmelon: "fruit",
  mussel: "seafood",
  mustard: "other",
  "mustard green": "produce",
  "mustard powder": "other",
  "mustard seed": "other",
  "mutsu apple": "fruit",
  naan: "other",
  "naan bread": "other",
  nacho: "other",
  "nacho cheese": "other",
  "nacho cheese doritos": "other",
  "nacho cheese sauce": "other",
  "nacho chip": "other",
  "nacho dip": "other",
  "naked juice": "other",
  "nam pla": "other",
  name: "produce",
  ñame: "produce",
  napa: "produce",
  "napa cabbage": "produce",
  "napa kimchi": "other",
  "nashi pear": "fruit",
  natto: "other",
  "natural peanut butter": "other",
  "nature valley bar": "other",
  "navel orange": "fruit",
  nduja: "meat",
  nectarine: "fruit",
  nerd: "other",
  nesquik: "dairy",
  nestea: "other",
  neufchatel: "dairy",
  neufchâtel: "dairy",
  "new mexico pepper": "produce",
  "new potato": "produce",
  "new york cheesecake": "other",
  "new york strip": "meat",
  "nilla wafer": "other",
  "nonfat dry milk": "other",
  "nonfat sour cream": "dairy",
  "nonfat yogurt": "dairy",
  nonpareil: "other",
  nopal: "produce",
  nopale: "produce",
  nori: "other",
  "nori sheet": "other",
  "nos energy": "other",
  "now and later": "other",
  "nuoc mam": "other",
  nutella: "other",
  nutmeg: "other",
  "nutri grain bar": "other",
  "nutter butters": "other",
  "oak leaf lettuce": "produce",
  "oat bran": "other",
  "oat milk": "dairy",
  oatly: "dairy",
  oatmeal: "other",
  "oatmeal cookie": "other",
  "oatmeal cooky": "other",
  "oatmeal packet": "other",
  oatmilk: "dairy",
  "oaxaca cheese": "dairy",
  octopus: "seafood",
  odwalla: "other",
  "oi sobagi": "other",
  oil: "other",
  "okonomiyaki sauce": "other",
  okra: "produce",
  olif: "fruit",
  olive: "fruit",
  "olive loaf": "meat",
  "olive oil": "other",
  "olive oil mayo": "other",
  "olive tapenade": "other",
  "omega 3": "other",
  "ong choy": "produce",
  onion: "produce",
  "onion powder": "other",
  "onion ring": "other",
  "onion rings snack": "other",
  "onion salt": "other",
  "oolong tea": "other",
  opah: "seafood",
  "opal apple": "fruit",
  "opo squash": "produce",
  orange: "fruit",
  "orange bell pepper": "produce",
  "orange blossom water": "other",
  "orange cauliflower": "produce",
  "orange chicken sauce": "other",
  "orange habanero": "produce",
  "orange juice": "other",
  "orange marmalade": "other",
  "orange soda": "other",
  "orange sweet potato": "produce",
  "orange tomato": "produce",
  "ore ida": "other",
  orecchiette: "other",
  oregano: "produce",
  oreo: "other",
  "organic egg": "dairy",
  "organic ketchup": "other",
  "organic milk": "dairy",
  "orville redenbacher": "other",
  orzo: "other",
  "oscar mayer bologna": "meat",
  "osso buco": "meat",
  ostrich: "meat",
  "oven roasted turkey": "meat",
  oxtail: "meat",
  oyster: "seafood",
  "oyster cracker": "other",
  "oyster mushroom": "produce",
  "oyster plant": "produce",
  "oyster sauce": "other",
  "p3 protein pack": "other",
  "pacific rose apple": "fruit",
  "pad thai": "other",
  "pad thai noodle": "other",
  "pad thai sauce": "other",
  "padron pepper": "produce",
  "padrón pepper": "produce",
  "pak choi": "produce",
  "palm sugar": "other",
  pam: "other",
  "panang curry paste": "other",
  pancake: "other",
  "pancake mix": "other",
  "pancake syrup": "other",
  pancetta: "meat",
  paneer: "dairy",
  "paneer cheese": "dairy",
  panela: "dairy",
  panini: "other",
  panko: "other",
  "panko breadcrumbs": "other",
  papad: "other",
  papadum: "other",
  papaya: "fruit",
  paprika: "other",
  paratha: "other",
  parmesan: "dairy",
  "parmesan cheese": "dairy",
  "parmigiano reggiano": "dairy",
  "parmigiano-reggiano": "dairy",
  parsley: "produce",
  parsnip: "produce",
  "part skim mozzarella": "dairy",
  "part skim ricotta": "dairy",
  "passion fruit": "fruit",
  passionfruit: "fruit",
  pasta: "other",
  "pasta salad": "other",
  "pasta sauce": "other",
  "pasta shells": "other",
  pastrami: "meat",
  "pasilla pepper": "produce", // Pasilla pepper variety
  pate: "other",
  patty: "meat", // generic meat patty
  "pattypan squash": "produce",
  pawpaw: "fruit",
  payday: "other",
  pea: "produce",
  "pea milk": "other",
  "pea shoot": "produce",
  "pea tendril": "produce",
  "peace tea": "other",
  peach: "fruit",
  "peach cup": "other",
  "peach yogurt": "dairy",
  peanut: "other",
  "peanut butter": "other",
  "peanut butter chips": "other",
  "peanut butter cookies": "other",
  "peanut butter cups": "other",
  "peanut oil": "other",
  "peanut sauce": "other",
  pear: "fruit",
  "pearl barley": "other",
  "pearl onion": "produce",
  pecan: "other",
  "pecan pie": "other",
  "pecan roll": "other",
  pecorino: "dairy",
  "pecorino romano": "dairy",
  "pecorino sardo": "dairy",
  "pecorino toscano": "dairy",
  pectin: "other",
  peep: "other",
  pellegrino: "other",
  penne: "other",
  "penne pasta": "other",
  peperoncino: "produce",
  pepita: "other",
  pepper: "other",
  "pepper jack": "dairy",
  peppercorns: "other",
  "peppered jerky": "other",
  "peppered turkey": "meat",
  peppermint: "produce",
  "peppermint candy": "other",
  "peppermint extract": "other",
  peppermints: "other",
  pepperoncini: "produce",
  pepperoncino: "produce",
  pepperoni: "meat",
  "pepperoni pizza": "other",
  "pepperoni slices": "other",
  "pepperoni sticks": "meat",
  pepsi: "other",
  "pepsi zero": "other",
  perch: "seafood",
  perilla: "produce",
  "perilla leaf": "produce",
  "perilla oil": "other",
  perrier: "other",
  "persian cucumber": "produce",
  "persian lime": "fruit",
  "persian melon": "fruit",
  persimmon: "fruit",
  "personal watermelon": "fruit",
  pesto: "other",
  "pesto sauce": "other",
  "petite potato": "produce",
  pheasant: "meat",
  "pho noodle": "other",
  "pho seasoning": "other",
  "pho spice": "other",
  "phyllo dough": "other",
  piccalilli: "other",
  pickle: "other",
  "pickle chip": "other",
  "pickle loaf": "meat",
  "pickle relish": "other",
  "pickle slice": "other",
  "pickle spear": "other",
  "pickled banana peppers": "other",
  "pickled carrot": "other",
  "pickled daikon": "other",
  "pickled ginger": "other",
  "pickled jalapeno": "other",
  "pickled jalapeño": "other",
  "pickled pepperoncini": "other",
  "pickled peppers": "other",
  "pickled plum": "other",
  "pickled vegetable": "other",
  "pickling cucumber": "produce",
  "picnic shoulder": "meat",
  "pico de gallo": "other",
  pie: "other",
  "pie pumpkin": "produce",
  "pigs foot": "meat",
  pike: "seafood",
  "pillsbury biscuit": "other",
  pilsner: "other",
  pimento: "produce",
  pimiento: "produce",
  "piñata apple": "fruit",
  "pine nut": "other",
  "pine nut hummus": "other",
  pineapple: "fruit",
  "pineapple cup": "other",
  "pineapple guava": "fruit",
  "pineapple juice": "other",
  "pink dragon fruit": "fruit",
  "pink guava": "fruit",
  "pink lady apple": "fruit",
  "pink lemonade": "other",
  "pinto bean": "other",
  "pirate's booty": "other",
  pirouette: "other",
  pistachio: "other",
  pita: "other",
  "pita bread": "other",
  "pita chip": "other",
  "pita pocket": "other",
  pitaya: "fruit",
  "pixy stix": "other",
  pizza: "other",
  "pizza bite": "other",
  "pizza crust": "other",
  "pizza dough": "other",
  "plain bagel": "other",
  "plain yogurt": "dairy",
  "plant based burger": "other",
  plantain: "produce",
  "plantain chip": "other",
  "planters peanut": "other",
  plum: "fruit",
  "plum sauce": "other",
  "plum tomato": "produce",
  plumcot: "fruit",
  pluot: "fruit",
  poblano: "produce",
  "poblano pepper": "produce",
  "point cut brisket": "meat",
  "pointed cabbage": "produce",
  "polar seltzer": "other",
  polenta: "other",
  "polish sausage": "meat",
  pollock: "seafood",
  pomegranate: "fruit",
  "pomegranate juice": "other",
  "pomegranate molass": "other",
  "pomegranate seed": "other",
  pomelo: "fruit",
  pompano: "seafood",
  "pont l'eveque": "dairy",
  "point reyes blue": "dairy", // Point Reyes blue cheese
  ponzu: "other",
  "ponzu sauce": "other",
  pop: "other",
  "pop rock": "other",
  "pop secret": "other",
  "pop tart": "other",
  popcorn: "other",
  "popcorn chicken": "other",
  "popcorn kernel": "other",
  poppadom: "other",
  "poppy seed": "other",
  "poppy seed dressing": "other",
  "poppyseed dressing": "other",
  popsicle: "other",
  porcini: "produce",
  "porcini mushroom": "produce",
  porgy: "seafood",
  pork: "meat",
  "pork belly": "meat",
  "pork butt": "meat",
  "pork chop": "meat",
  "pork cutlet": "meat",
  "pork ear": "meat",
  "pork feet": "meat",
  "pork gravy": "other",
  "pork hock": "meat",
  "pork hot dog": "meat",
  "pork jerky": "meat",
  "pork jowl": "meat",
  "pork kabob": "meat",
  "pork kidney": "meat",
  "pork liver": "meat",
  "pork loin": "meat",
  "pork loin roast": "meat",
  "pork meatballs": "meat",
  "pork ribs": "meat",
  "pork rinds": "other",
  "pork roast": "meat",
  "pork sausage": "meat",
  "pork scallopini": "meat",
  "pork shank": "meat",
  "pork shoulder": "meat",
  "pork shoulder roast": "meat",
  "pork sirloin": "meat",
  "pork stir fry": "meat",
  "pork tenderloin": "meat",
  "pork tongue": "meat",
  "port salut": "dairy",
  portabella: "produce",
  porter: "other",
  porterhouse: "meat",
  "porterhouse steak": "meat",
  portobello: "produce",
  "portobello mushroom": "produce",
  "pot pie": "other",
  "pot roast": "meat",
  potato: "produce",
  "potato chip": "other",
  "potato flake": "other",
  "potato pancake": "other",
  "potato salad": "other",
  "potato starch": "other",
  "potato wedge": "other",
  potsticker: "other",
  "potsticker wrapper": "other",
  "potted meat": "other",
  "poultry seasoning": "other",
  "pound cake": "other",
  "pound of beef": "meat",
  "powdered milk": "other",
  "powdered sugar": "other",
  powerade: "other",
  pozole: "other",
  "praline pecan": "other",
  prawn: "seafood",
  "prawn cracker": "other",
  "premier protein": "other",
  "prepared horseradish": "other",
  preserf: "other",
  "preserved vegetable": "other",
  "pressed juice": "other",
  pretzel: "other",
  "pretzel bite": "other",
  "pretzel rod": "other",
  "pretzel stick": "other",
  "pretzel twist": "other",
  "prickly pear": "fruit",
  "prime rib": "meat",
  pringle: "other",
  probiotic: "other",
  "probiotic drink": "other",
  "probiotic yogurt": "dairy",
  profiterole: "other",
  "propel water": "other",
  prosciutto: "other",
  "prosciutto chip": "other",
  prosecco: "other",
  "protein bar": "other",
  "protein powder": "other",
  "protein shake": "other",
  provolone: "dairy",
  "provolone cheese": "dairy",
  prune: "other",
  "prune plum": "fruit",
  "pu erh tea": "other",
  "pudding cup": "other",
  "pudding mix": "other",
  "puff pastry": "other",
  "pulled pork": "other",
  pummelo: "fruit",
  "pumpernickel bread": "other",
  pumpkin: "produce",
  "pumpkin bread": "other",
  "pumpkin butter": "other",
  "pumpkin pie": "other",
  "pumpkin pie spice": "other",
  "pumpkin seed": "other",
  "puppy chow": "other",
  "pure leaf tea": "other",
  puri: "other",
  "purified water": "other",
  "purple asparagus": "produce",
  "purple basil": "produce",
  "purple bell pepper": "produce",
  "purple cabbage": "produce",
  "purple carrot": "produce",
  "purple cauliflower": "produce",
  "purple passion fruit": "fruit",
  "purple plum": "fruit",
  "purple potato": "produce",
  "purple sweet potato": "produce",
  "purple top turnip": "produce",
  "puttanesca sauce": "other",
  quail: "meat",
  "quail egg": "dairy",
  "quaker oat": "other",
  "quaker rice cakes": "other",
  quark: "dairy",
  quesadilla: "other",
  queso: "other",
  "queso blanco": "dairy",
  "queso dip": "other",
  "queso fresco": "dairy",
  "queso oaxaca": "dairy",
  "queso sauce": "other",
  "quest bar": "other",
  "quick oat": "other",
  quince: "fruit",
  quinoa: "other",
  "quinoa milk": "other",
  rabbit: "meat",
  "rabbit leg": "meat",
  "rabbit loin": "meat",
  "rack of lamb": "meat",
  raclette: "dairy",
  radicchio: "produce",
  radish: "produce",
  "radish kimchi": "other",
  "rainbow carrot": "produce",
  "rainbow chard": "produce",
  "rainbow trout": "seafood",
  "rainier cherry": "fruit",
  raisin: "other",
  "raisin bran": "other",
  raman: "other",
  rambutan: "fruit",
  "ramen noodle": "other",
  ramyeon: "other",
  ramp: "produce", // wild leek/onion
  ranch: "other",
  "ranch dip": "other",
  "ranch dressing": "other",
  rapini: "produce",
  "rare roast beef": "meat",
  "ras el hanout": "other",
  "rasam powder": "other",
  raspberry: "fruit",
  "raspberry jam": "other",
  "raspberry lemonade": "other",
  "raspberry vinaigrette": "other",
  "rau ram": "produce",
  ravioli: "other",
  "raw honey": "other",
  "raw sugar": "other",
  "ready pac salad": "other",
  reblochon: "dairy",
  "red anjou pear": "fruit",
  "red apple": "fruit",
  "red bartlett pear": "fruit",
  "red bean paste": "other",
  "red beet": "produce",
  "red bell pepper": "produce",
  "red bull": "other",
  "red cabbage": "produce",
  "red chili": "produce",
  "red currant": "fruit",
  "red curry paste": "other",
  "red delicious apple": "fruit",
  "red enchilada sauce": "other",
  "red grape": "fruit",
  "red habanero": "produce",
  "red jalapeno": "produce",
  "red kale": "produce",
  "red leaf lettuce": "produce",
  "red leicester": "dairy",
  "red miso": "other",
  "red mulberry": "fruit",
  "red onion": "produce",
  "red pepper": "other",
  "red pepper flakes": "other",
  "red plum": "fruit",
  "red potato": "produce",
  "red radish": "produce",
  "red rice": "other",
  "red snapper": "seafood",
  "red velvet cake": "other",
  "red velvet cake mix": "other",
  "red vine": "other",
  "red wine": "other",
  "red wine vinegar": "other",
  "reddi wip": "other",
  rees: "other",
  "reeses cup": "other",
  "refried bean": "other",
  "reign energy": "other",
  relish: "other",
  remoulade: "other",
  renkon: "produce",
  rhubarb: "produce",
  "rhubarb stalk": "produce",
  rib: "meat", // generic meat rib
  "rib chop": "meat",
  ribeye: "meat",
  "ribeye steak": "meat",
  rice: "other",
  "rice a roni": "other",
  "rice cake": "other",
  "rice cakes": "other",
  "rice chex": "other",
  "rice crackers": "other",
  "rice krispies": "other",
  "rice krispies treats": "other",
  "rice milk": "dairy",
  "rice noodles": "other",
  "rice paper": "other",
  "rice pilaf": "other",
  "rice pudding": "other",
  "rice seasoning": "other",
  "rice stick noodles": "other",
  "rice sticks": "other",
  "rice vermicelli": "other",
  "rice vinegar": "other",
  "rice wine": "other",
  "rice wine vinegar": "other",
  ricotta: "dairy",
  "ricotta cheese": "dairy",
  "ricotta salata": "dairy",
  rigatoni: "other",
  "ripe papaya": "fruit",
  "ripe plantain": "produce",
  "ritz bit": "other",
  "ritz cracker": "other",
  roast: "meat", // generic meat roast
  "roast beef": "meat",
  "roasted almond": "other",
  "roasted cashew": "other",
  "roasted chickpea": "other",
  "roasted garlic": "other",
  "roasted peanut": "other",
  "roasted red pepper hummus": "other",
  "roasted red peppers": "other",
  "roasted sesame oil": "other",
  "rock candy": "other",
  rocket: "produce",
  rockfish: "seafood",
  "rockstar energy": "other",
  roe: "seafood", // fish roe / caviar
  "rogan josh sauce": "other",
  "rold gold pretzel": "other",
  roll: "other",
  "rolled oat": "other",
  "roma tomato": "produce", // culinary usage
  romaine: "produce",
  "romaine lettuce": "produce",
  romanesco: "produce",
  "romanesco broccoli": "produce",
  romano: "dairy",
  "romano bean": "produce",
  "romano cheese": "dairy",
  "rome apple": "fruit",
  "rooster sauce": "other",
  "root beer": "other",
  roquefort: "dairy",
  "rose water": "other",
  "rose wine": "other",
  rosemary: "produce",
  roti: "other",
  rotini: "other",
  "rotisserie chicken": "other",
  "round roast": "meat",
  "round zucchini": "produce",
  ruffle: "other",
  rum: "other",
  "rump roast": "meat",
  "russet potato": "produce",
  "russian kale": "produce",
  rutabaga: "produce",
  "rye bread": "other",
  saba: "seafood",
  sablefish: "seafood",
  "sabra hummus": "other",
  "safflower oil": "other",
  sage: "produce",
  sake: "other",
  "salad dressing": "other",
  "salad kit": "other",
  salami: "meat",
  "salami slice": "other",
  salmon: "seafood",
  salmonberry: "fruit",
  salsa: "other",
  "salsa fresca": "other",
  "salsa roja": "other",
  "salsa verde": "other",
  salsify: "produce",
  salt: "other",
  "salt and vinegar chips": "other",
  "salt water taffy": "other",
  "salted butter": "dairy",
  "salted peanuts": "other",
  saltines: "other",
  "salvadorian crema": "dairy",
  "sambar powder": "other",
  samoa: "other",
  samosa: "other",
  "san marzano tomato": "produce",
  "san pellegrino": "other",
  sandwich: "other",
  sanma: "seafood",
  "santa claus melon": "fruit",
  sapodilla: "fruit",
  sardine: "seafood",
  "satay sauce": "other",
  satsuma: "fruit",
  "saturn peach": "fruit",
  sauerkraut: "other",
  sausage: "meat",
  "sausage biscuit": "other",
  "sausage gravy": "other",
  "sausage link": "other",
  "sausage patty": "other",
  savory: "produce",
  "savoy cabbage": "produce",
  "savoy spinach": "produce",
  "sawleaf herb": "produce",
  "sawtooth coriander": "produce",
  sazon: "other",
  sazón: "other",
  scallion: "produce",
  scallop: "seafood",
  "scallop squash": "produce",
  "scalloped potato": "other",
  "schisandra berry": "fruit",
  "schweppes ginger ale": "other",
  scone: "other",
  scorzonera: "produce",
  scotch: "other",
  "scotch bonnet": "produce",
  scrapple: "meat",
  scup: "seafood",
  sanddab: "seafood", // sanddab fish
  "sea bass": "seafood",
  "sea buckthorn": "fruit",
  "sea cucumber": "seafood", // sea cucumber
  "sea salt": "other",
  "sea urchin": "seafood",
  "seasoned breadcrumbs": "other",
  "seasoned salt": "other",
  seaweed: "other",
  "seaweed sheet": "other",
  "seaweed snack": "other",
  "seckel pear": "fruit",
  "seedless grape": "fruit",
  "seedless watermelon": "fruit",
  seltzer: "other",
  "seltzer water": "other",
  "semi sweet chocolate chip": "other",
  senbei: "other",
  serrano: "produce",
  "serrano ham": "meat",
  "serrano pepper": "produce",
  serviceberry: "fruit",
  "sesame bagel": "other",
  "sesame ginger dressing": "other",
  "sesame oil": "other",
  "sesame seed": "other",
  "sesame seeds": "other",
  "white sesame seed": "other",
  "white sesame seeds": "other",
  "black sesame seed": "other",
  "black sesame seeds": "other",
  "toasted sesame seed": "other",
  "toasted sesame seeds": "other",
  "toasted sesame oil": "other",
  "seven spice": "other",
  "seville orange": "fruit",
  shallot: "produce",
  "shanghai bok choy": "produce",
  shaoxing: "other", // shaoxing wine shorthand
  "shaoxing wine": "other",
  "shaoxing rice wine": "other",
  "shaoxing cooking wine": "other",
  "sharlyn melon": "fruit",
  "sharp cheddar": "dairy",
  sheep: "meat", // generic lamb/mutton
  "sheet cake": "other",
  shell: "other",
  "shelling pea": "produce",
  "shells and cheese": "other",
  sherbet: "other",
  "sherry vinegar": "other",
  "shichimi togarashi": "other",
  shiitake: "produce",
  "shiitake mushroom": "produce",
  "shimeji mushroom": "produce",
  "shin ramyun": "other",
  "shirataki noodle": "other",
  shishito: "produce",
  "shishito pepper": "produce",
  shiso: "produce",
  "short grain rice": "other",
  "short rib": "meat",
  "shoulder roast": "meat",
  "shredded cheese": "dairy",
  "shredded coconut": "other",
  "shredded mozzarella": "dairy",
  shrimp: "seafood",
  "shrimp chip": "other",
  "shrimp paste": "other",
  "shrimp salad": "other",
  "shumai wrapper": "other",
  "sheep milk feta": "dairy", // sheep milk feta cheese
  "sichuan chili paste": "other",
  "sichuan peppercorn": "other",
  "sichuan peppercorns": "other",
  "sierra mist": "other",
  "silken tofu": "other",
  "simmer sauce": "other",
  "simple syrup": "other",
  "simply lemonade": "other",
  "single cream": "dairy",
  sirloin: "meat",
  "sirloin steak": "meat",
  "skim milk": "dairy",
  "skinny pop": "other",
  skipjack: "seafood",
  "skipjack tuna": "seafood",
  "skirt steak": "meat",
  skittle: "other",
  skyr: "dairy",
  "slaw dressing": "other",
  "sliced cheese": "dairy",
  "sliced chicken": "meat",
  "sliced ham": "meat",
  "sliced roast beef": "meat",
  "sliced turkey": "meat",
  "slider bun": "other",
  "slim fast": "other",
  "slim jim": "meat",
  "slim jims": "other", // processed meat stick, not raw
  "small curd cottage cheese": "dairy",
  "smartfood popcorn": "other",
  "smartfood white cheddar": "other",
  smartwater: "other",
  smarty: "other",
  smelt: "seafood",
  "smoked almond": "other",
  "smoked gouda": "dairy",
  "smoked ham": "meat",
  "smoked mozzarella": "dairy",
  "smoked paprika": "other",
  "smoked provolone": "dairy",
  "smoked sausage": "meat",
  "smoked turkey": "meat",
  smoothie: "other",
  "snack pack": "other",
  "snake bean": "produce",
  "snap bean": "produce",
  "snap pea": "produce",
  "snapdragon apple": "fruit",
  snapper: "seafood",
  snapple: "other",
  "snapple iced tea": "other",
  snicker: "other",
  snickerdoodle: "other",
  "snow crab": "seafood",
  "snow pea": "produce",
  "snyder's pretzel": "other",
  "soba noodle": "other",
  soda: "other",
  "soft pretzel": "other",
  "soft taco shell": "other",
  sole: "seafood",
  "somen noodle": "other",
  soppressata: "meat",
  sorbet: "other",
  sorrel: "produce",
  soup: "other",
  "soup bone": "meat",
  "sour candy": "other",
  "sour cherry": "fruit",
  "sour cream": "dairy",
  "sour cream and onion chip": "other",
  "sour gummy worm": "other",
  "sour patch kid": "other",
  "sourdough bread": "other",
  soursop: "fruit",
  "southwestern dressing": "other",
  "soy milk": "dairy", // plant-based milk in dairy section
  "soy sauce": "other",
  "soybean sprout": "produce",
  soymilk: "dairy", // plant-based milk in dairy section
  spaghetti: "other",
  "spaghetti noodle": "other",
  "spaghetti sauce": "other",
  "spaghetti squash": "produce",
  spam: "other",
  "spanish chorizo": "meat",
  "spanish onion": "produce",
  "spanish rice": "other",
  "spare rib": "meat",
  "sparkling water": "other",
  "sparkling wine": "other",
  spearmint: "produce",
  "special k": "other",
  "special sauce": "other",
  speck: "meat",
  "spicy bbq sauce": "other",
  "spicy brown mustard": "other",
  "spicy mustard": "other",
  spinach: "produce",
  "spinach dip": "other",
  "spinach tortilla": "other",
  spindrift: "other",
  "spiral ham": "meat",
  splenda: "other",
  "sports drink": "other",
  "spreadable butter": "dairy",
  "spring mix": "produce",
  "spring onion": "produce",
  "spring roll": "other",
  "spring roll wrapper": "other",
  "spring water": "other",
  sprinkle: "other",
  sprite: "other",
  "sprite melon": "fruit",
  squash: "produce", // generic squash
  "squash blossom": "produce",
  "squeaky cheese": "dairy",
  squid: "seafood",
  sriracha: "other",
  "sriracha mayo": "other",
  "sriracha sauce": "other",
  ssamjang: "other",
  "st louis rib": "meat",
  "standing rib roast": "meat",
  "star anise": "other",
  "star fruit": "fruit",
  "starbucks doubleshot": "other",
  "starbucks frappuccino": "other",
  "starbucks iced coffee": "other",
  starburst: "other",
  "starkrimson pear": "fruit",
  steak: "meat",
  "steak sauce": "other",
  "steak seasoning": "other",
  "steel cut oat": "other",
  stevia: "other",
  "stew meat": "meat",
  "stewed tomato": "other",
  "sticky bun": "other",
  "sticky rice": "other",
  stilton: "dairy",
  "stir fry": "other",
  "stir fry sauce": "other",
  "stone ground mustard": "other",
  stout: "other",
  "stove top stuffing": "other",
  "stovetop stuffing": "other",
  "straightneck squash": "produce",
  "strained yogurt": "dairy",
  "strained yogurt cheese": "dairy",
  "straw mushroom": "produce",
  strawberry: "fruit",
  "strawberry cheesecake": "other",
  "strawberry guava": "fruit",
  "strawberry jam": "other",
  "strawberry lemonade": "other",
  "strawberry milk": "dairy",
  "strawberry pie": "other",
  "strawberry soda": "other",
  "strawberry yogurt": "dairy",
  "string bean": "produce",
  "string cheese": "dairy",
  "strip steak": "meat",
  "striped bass": "seafood",
  strudel: "other",
  struffoli: "other",
  "stubb's bbq sauce": "other",
  "stuffed olif": "other",
  "stuffed shell": "other",
  stuffing: "other",
  "stuffing mix": "other",
  "sub roll": "other",
  "sub sandwich": "other",
  sucker: "other",
  sugar: "other",
  "sugar apple": "fruit",
  "sugar bee apple": "fruit",
  "sugar cookie": "other",
  "sugar cookies": "other",
  "sugar pumpkin": "produce",
  "sugar snap pea": "produce",
  "suja juice": "other",
  sultana: "other",
  sumac: "other",
  "summer sausage": "meat",
  "summer savory": "produce",
  "summer squash": "produce",
  "sumo citrus": "fruit",
  "sumo orange": "fruit",
  "sun chip": "other",
  "sun dried tomato": "other",
  "sun dried tomato pesto": "other",
  sunchoke: "produce",
  "sunflower butter": "other",
  "sunflower oil": "other",
  "sunflower seed": "other",
  "sunflower seed butter": "other",
  "sunflower sprouts": "produce", // young sunflower shoots
  sunkist: "other",
  sushi: "other",
  "sushi rice": "other",
  suzuki: "seafood",
  swede: "produce",
  "swedish fish": "other",
  "swedish meatballs": "other",
  "sweet and sour sauce": "other",
  "sweet baby ray'": "other",
  "sweet banana pepper": "produce",
  "sweet basil": "produce",
  "sweet bean sauce": "other",
  "sweet cherry": "fruit",
  "sweet chili sauce": "other",
  "sweet corn": "produce",
  "sweet cream butter": "dairy",
  "sweet italian sausage": "meat",
  "sweet onion": "produce",
  "sweet pea": "produce",
  "sweet pepper": "produce",
  "sweet pickle": "other",
  "sweet potato": "produce",
  "sweet potato chip": "other",
  "sweet potato noodle": "other",
  "sweet potato starch noodle": "other",
  "sweet relish": "other",
  "sweet roll": "other",
  "sweet tart": "other",
  "sweet tea": "other",
  "sweetango apple": "fruit",
  sweetbreads: "meat",
  "sweetened almond milk": "dairy", // plant-based milk in dairy section
  "sweetened condensed milk": "other",
  sweetsop: "fruit",
  swiss: "dairy",
  "swiss chard": "produce",
  "swiss cheese": "dairy",
  "swiss miss pudding": "other",
  "swiss roll": "other",
  swordfish: "seafood",
  syrup: "other",
  "szechuan peppercorn": "other",
  "szechuan peppercorns": "other",
  "t-bone": "meat",
  "t-bone steak": "meat",
  tabasco: "other",
  "tabasco sauce": "other",
  "table cream": "dairy",
  "table salt": "other",
  taco: "other",
  "taco bell sauce": "other",
  "taco kit": "other",
  "taco sauce": "other",
  "taco seasoning": "other",
  "taco shell": "other",
  taffy: "other",
  tagalong: "other",
  tahini: "other",
  "tahini dressing": "other",
  tai: "seafood",
  "taiwanese cabbage": "produce",
  tako: "seafood",
  "takoyaki sauce": "other",
  takuan: "other",
  taleggio: "dairy",
  tamale: "other",
  tamari: "other",
  tamarillo: "fruit",
  tamarind: "fruit",
  "tamarind chutney": "other",
  "tamarind concentrate": "other",
  "tamarind drink": "other",
  "tamarind paste": "other",
  "tandoori masala": "other",
  tangelo: "fruit",
  tangerine: "fruit",
  tangor: "fruit",
  tapatio: "other",
  "tapatio hot sauce": "other",
  tapenade: "other",
  "tapioca pudding": "other",
  "tapioca starch": "other",
  taro: "produce",
  "taro chip": "other",
  "taro root": "produce",
  tarragon: "produce",
  tart: "other",
  "tart cherry": "fruit",
  "tartar sauce": "other",
  "tater tot": "other",
  tatso: "produce",
  tatsoi: "produce",
  tayberry: "fruit",
  "taylor's gold pear": "fruit",
  tea: "other",
  "tea bag": "other",
  "teddy graham": "other",
  "teething biscuit": "other",
  teleme: "dairy",
  tempeh: "other",
  tempura: "other",
  tenderloin: "meat",
  tequila: "other",
  "teriyaki glaze": "other",
  "teriyaki jerky": "other",
  "teriyaki marinade": "other",
  "teriyaki sauce": "other",
  tetilla: "dairy",
  "texas bbq sauce": "other",
  "texas pete": "other",
  "thai basil": "produce",
  "thai chili": "produce",
  "thai chili paste": "other",
  "thai chili sauce": "other",
  "thai curry paste": "other",
  "thai eggplant": "produce",
  "thai fish sauce": "other",
  "thai iced tea mix": "other",
  "thai shrimp paste": "other",
  "thai sweet chili sauce": "other",
  "thai tea": "other",
  "thick cut bacon": "meat",
  thigh: "meat", // generic meat thigh
  thimbleberry: "fruit",
  "thin mint": "other",
  "thompson seedless grape": "fruit",
  "thousand island": "other",
  "thousand island dressing": "other",
  "three bean salad": "other",
  thuringer: "meat",
  thyme: "produce",
  "tian jin preserved vegetable": "other",
  tianmianjiang: "other",
  "tic tac": "other",
  "tiger nut milk": "other",
  "tikka masala sauce": "other",
  tilapia: "seafood",
  tilefish: "seafood",
  tiramisu: "other",
  tobiko: "seafood", // flying fish roe
  "toaster pastry": "other",
  "toaster strudel": "other",
  "toddler meal": "other",
  tofu: "other",
  "tofu skin": "other",
  "tomahawk steak": "meat",
  tomatillo: "produce",
  "tomatillo salsa": "other",
  tomato: "produce",
  "tomato juice": "other",
  "tomato ketchup": "other",
  "tomato paste": "other",
  "tomato puree": "other",
  "tomato sauce": "other",
  "tomato tortilla": "other",
  tomme: "dairy",
  "tonic water": "other",
  "tonkatsu sauce": "other",
  "tootsie roll": "other",
  "top sirloin": "meat",
  tortellini: "other",
  tortilla: "other",
  "tortilla chip": "other",
  tostada: "other",
  "tostada shell": "other",
  tostito: "other",
  "tostitos scoop": "other",
  tostone: "other",
  "trail mix": "other",
  "tree tomato": "fruit",
  "tres leches cake": "other",
  "tri tip": "meat",
  "tri tip roast": "meat",
  "tri-tip": "meat",
  "tribe hummus": "other",
  tripe: "meat",
  "triple sec": "other",
  triscuit: "other",
  trix: "other",
  trout: "seafood",
  tsukemono: "other",
  tteok: "other",
  tuna: "seafood",
  "tuna salad": "other",
  "turbinado sugar": "other",
  turbot: "seafood",
  turkey: "meat",
  "turkey bacon": "meat",
  "turkey breast": "meat",
  "turkey burger": "meat",
  "turkey cutlet": "meat",
  "turkey drumstick": "meat",
  "turkey giblet": "meat",
  "turkey gravy": "other",
  "turkey hot dog": "meat",
  "turkey jerky": "other",
  "turkey leg": "meat",
  "turkey meatballs": "meat",
  "turkey neck": "meat",
  "turkey pot pie": "other",
  "turkey sausage": "meat",
  "turkey tenderloin": "meat",
  "turkey thigh": "meat",
  "turkey wing": "meat",
  turmeric: "produce",
  "turmeric powder": "other",
  "turmeric root": "produce",
  turnip: "produce",
  "turnip green": "produce",
  turnover: "other",
  "tuscan kale": "produce",
  "tv dinner": "other",
  "twice baked potato": "other",
  twinkie: "other",
  twix: "other",
  twizzler: "other",
  tzatziki: "other",
  "udon noodle": "other",
  "ugli fruit": "fruit",
  umeboshi: "other",
  unagi: "seafood",
  "unsalted butter": "dairy",
  "unsweetened almond milk": "dairy", // plant-based milk in dairy section
  "unsweetened tea": "other",
  ube: "produce", // purple yam
  uni: "seafood", // sea urchin roe
  "utz chip": "other",
  "v8 juice": "other",
  valentina: "other",
  "valentina hot sauce": "other",
  "vanilla almond milk": "dairy", // plant-based milk in dairy section
  "vanilla cake": "other",
  "vanilla cake mix": "other",
  "vanilla extract": "other",
  "vanilla pudding": "other",
  "vanilla soy milk": "other",
  "vanilla wafer": "other",
  "vanilla yogurt": "dairy",
  veal: "meat",
  "veal breast": "meat",
  "veal chop": "meat",
  "veal cutlet": "meat",
  "veal loin": "meat",
  "veal rack": "meat",
  "veal rib": "meat",
  "veal scallopini": "meat",
  "veal shank": "meat",
  "veal shoulder": "meat",
  "veal stew meat": "meat",
  "veal tenderloin": "meat",
  "vegetable broth": "other",
  "vegetable juice": "other",
  "vegetable oil": "other",
  "vegetable pear": "produce",
  "vegetable stock": "other",
  "veggie burger": "other",
  "veggie chip": "other",
  "veggie pizza": "other",
  "veggie straw": "other",
  velveeta: "dairy",
  "velveeta shell": "other",
  venison: "meat",
  "venison chop": "meat",
  "venison jerky": "meat",
  "venison roast": "meat",
  "venison steak": "meat",
  "venison tenderloin": "meat",
  "verde sauce": "other",
  vermouth: "other",
  vernor: "other",
  "vidalia onion": "produce",
  "vienna sausage": "other",
  "vietnamese basil": "produce",
  "vietnamese coffee": "other",
  "vietnamese coriander": "produce",
  "vietnamese fish sauce": "other",
  "vietnamese mint": "produce",
  vinaigrette: "other",
  "vindaloo sauce": "other",
  "vine tomato": "produce",
  vinegar: "other",
  "vintage seltzer": "other",
  "virginia ham": "meat",
  "vita coco": "other",
  vitamin: "other",
  "vitamin c": "other",
  "vitamin d": "other",
  "vitamin water": "other",
  vitaminwater: "other",
  vodka: "other",
  "vodka sauce": "other",
  "voss water": "other",
  "wafer cooky": "other",
  waffle: "other",
  "waffle fry": "other",
  "waffle mix": "other",
  wahoo: "seafood",
  wakame: "other",
  "waldorf salad": "other",
  "walla walla onion": "produce",
  walleye: "seafood",
  walnut: "other",
  warhead: "other",
  wasabi: "produce",
  "wasabi almond": "other",
  "wasabi paste": "other",
  "wasabi pea": "other",
  "wasabi root": "produce",
  "water chestnut": "produce",
  "water chestnuts": "produce",
  "water crackers": "other",
  "water spinach": "produce",
  watercress: "produce",
  "waterloo sparkling water": "other",
  watermelon: "fruit",
  watermelons: "fruit", // plural form
  "watermelon radish": "produce",
  "wax bean": "produce",
  "wedding cake": "other",
  "welchs fruit snack": "other",
  wensleydale: "dairy",
  "werther's original": "other",
  "west indian pumpkin": "produce",
  "wet cat food": "other",
  "wet dog food": "other",
  "wheat berry": "other",
  "wheat bread": "other",
  "wheat chex": "other",
  "wheat thin": "other",
  "whey protein": "other",
  "whipped butter": "dairy",
  "whipped cream": "dairy",
  "whipped cream cheese": "dairy",
  "whipping cream": "dairy",
  whiskey: "other",
  "white asparagus": "produce",
  "white bell pepper": "produce",
  "white bread": "other",
  "white cake mix": "other",
  "white carrot": "produce",
  "white cauliflower": "produce",
  "white cheddar": "dairy",
  "white chocolate chip": "other",
  "white corn": "produce",
  "white currant": "fruit",
  "white egg": "dairy",
  "white eggplant": "produce",
  "white gravy": "other",
  "white guava": "fruit",
  "white hominy": "other",
  "white kimchi": "other",
  "white miso": "other",
  "white mulberry": "fruit",
  "white mushroom": "produce",
  "white nectarine": "fruit",
  "white onion": "produce",
  "white peach": "fruit",
  "white pepper": "other",
  "white potato": "produce",
  "white pudding": "meat",
  "white pumpkin": "produce",
  "white radish": "produce",
  "white rice": "other",
  "white sugar": "other",
  "white sweet potato": "produce",
  "white turnip": "produce",
  "white vinegar": "other",
  "white wine": "other",
  "white wine vinegar": "other",
  whiting: "seafood",
  "whole beef tenderloin": "meat",
  "whole chicken": "meat",
  "whole duck": "meat",
  "whole grain bread": "other",
  "whole grain mustard": "other",
  "whole milk": "dairy",
  "whole milk mozzarella": "dairy",
  "whole milk ricotta": "dairy",
  "whole milk yogurt": "dairy",
  "whole tomato": "other", // canned whole tomatoes
  "whole tomatoes": "other", // canned whole tomatoes
  "whole turkey": "meat",
  "whole wheat bread": "other",
  "whole wheat flour": "other",
  "whole wheat tortilla": "other",
  "wholly guacamole": "other",
  "wide rice noodles": "other",
  wiener: "meat",
  "wild arugula": "produce",
  "wild boar": "meat",
  "wild rice": "other",
  "wildflower honey": "other",
  wine: "other",
  wineberry: "fruit",
  "winesap apple": "fruit",
  "wing sauce": "other",
  "winter melon": "produce",
  "winter savory": "produce",
  "winter squash": "produce",
  "wise chip": "other",
  wolfberry: "fruit",
  "wonderful pistachio": "other",
  "wong bok": "produce",
  "wonton chip": "other",
  "wonton wrapper": "other",
  "wood ear mushroom": "produce",
  "worcestershire sauce": "other",
  wrap: "other",
  "xo sauce": "other",
  "ya cai": "other",
  "yakisoba sauce": "other",
  yam: "produce",
  "yard long bean": "produce",
  yautia: "produce",
  yeast: "other",
  "yellow bean": "produce",
  "yellow beet": "produce",
  "yellow bell pepper": "produce",
  "yellow cake mix": "other",
  "yellow carrot": "produce",
  "yellow cheddar": "dairy",
  "yellow corn": "produce",
  "yellow curry paste": "other",
  "yellow dragon fruit": "fruit",
  "yellow hominy": "other",
  "yellow miso": "other",
  "yellow mustard": "other",
  "yellow mustard seed": "other",
  "yellow nectarine": "fruit",
  "yellow onion": "produce",
  "yellow passion fruit": "fruit",
  "yellow peach": "fruit",
  "yellow pickled radish": "other",
  "yellow plantain": "produce",
  "yellow plum": "fruit",
  "yellow potato": "produce",
  "yellow squash": "produce",
  "yellow tomato": "produce",
  "yellow watermelon": "fruit",
  "yellow zucchini": "produce",
  "yellowfin tuna": "seafood",
  yellowtail: "seafood",
  "yerba mate": "other",
  yogurt: "dairy",
  "yogurt drink": "dairy",
  "yoo hoo": "other",
  "york peppermint patty": "other",
  "young coconut": "fruit",
  "young ginger": "produce",
  "young gouda": "dairy",
  "yu choy": "produce",
  yuba: "other",
  yuca: "produce",
  "yuca chip": "other",
  "yuca root": "produce",
  "yukon gold potato": "produce",
  yuzu: "fruit",
  "yuzu juice": "other",
  "yuzu kosho": "other",
  "za'atar": "other",
  zeppole: "other",
  "zico coconut water": "other",
  ziti: "other",
  zucchini: "produce",
  "zucchini bread": "other",
  "zucchini flower": "produce",
};
